/**
 * Translations for the Advanced Retirement Calculator
 * Currently only Hebrew (HEB) is supported
 */

export const translations = {
  HEB: {
    title: "מחשבון פרישה מתקדם",
    tabs: {
      inputs: "נתוני בסיס",
      events: "אירועי חיים",
      assumptions: "הנחות תשואה",
      breakdown: "פירוט נכסים",
      pension: "פנסיה",
    },
    advancedSection: {
      title: "הגדרות מתקדמות",
      subtitle: "שיעורי משיכה, אינפלציה, הנחות תשואה ופירוט נכסים",
      tabSettings: "הגדרות",
      tabReturns: "הנחות תשואה וסיכון",
      tabBreakdown: "פירוט נכסים",
    },
    inputs: {
      gender: "מין",
      genderHelp: "משפיע על גיל הפרישה החוקי (67 לגבר, 65 לאישה)",
      genderMale: "זכר",
      genderFemale: "נקבה",
      currentAge: "גיל נוכחי",
      currentAgeHelp: "הגיל שלך היום",
      retirementAge: "גיל פרישה מתוכנן",
      retirementAgeHelp: "הגיל בו אתה מתכנן להפסיק לעבוד",
      lifeExpectancy: "תוחלת חיים",
      lifeExpectancyHelp: "תוחלת החיים הצפויה לצורך חישוב התקציב",
      monthlySpend: "הוצאות חודשיות",
      monthlySpendHelp: "סכום ההוצאות החודשיות שאתה צופה בפרישה",
      monthlyIncome: "הכנסה חודשית",
      monthlyIncomeHelp: "סך ההכנסה החודשית נטו (כולל משכורת, הכנסות נוספות)",
      monthlySavings: "חיסכון חודשי",
      monthlySavingsHelp: "נגזר אוטומטית: הכנסה פחות הוצאות",
      syncFromCashflow: "חשב אוטומטית מ-6 החודשים האחרונים",
      coupleToggle: "תכנון כזוג",
      coupleToggleHelp: "פצל את ההכנסה בין שני בני זוג, לכל אחד גיל, מין וגיל פרישה משלו",
      partner1: "בן/בת זוג 1",
      partner2: "בן/בת זוג 2",
      partnerIncome: "הכנסה חודשית",
      householdIncome: "הכנסת משק בית (סה״כ)",
      partnerGender: "מין",
      partnerCurrentAge: "גיל נוכחי",
      partnerRetirementAge: "גיל פרישה",
      withdrawalRate: "אחוז משיכה (%)",
      withdrawalRateHelp: "אחוז המשיכה השנתי מהתיק (4% נחשב בטוח)",
      inflation: "אינפלציה (%)",
      inflationHelp: "שיעור האינפלציה השנתי הצפוי",
      startingPortfolio: "תיק התחלתי",
      startingPortfolioHelp: "שווי התיק הנוכחי שלך",
    },
    toggles: {
      includeRealestate: "כלול נדל״ן לא נזיל",
      includeRealestateHelp: "האם לכלול נדל״ן שאינו נזיל בתיק ההשקעות",
      includePension: "כלול פנסיה לפני גיל פרישה",
      includePensionHelp: "האם לכלול קרנות פנסיה לפני גיל הפרישה",
      includeUnvestedRSU: "כלול RSU לא מוקנים",
      includeUnvestedRSUHelp: "האם לכלול RSUs שטרם הבשילו כאירועי חיים",
      monteCarlo: "הפעל Monte Carlo",
      monteCarloHelp: "הפעל סימולציה סטוכסטית לחישוב הסתברות הצלחה",
      advancedSettings: "הגדרות מתקדמות",
    },
    results: {
      fireNumber: "מספר FIRE",
      fireNumberHelp: "הסכום שאתה צריך כדי לפרוש מוקדם",
      yearsToFire: "שנים עד FIRE",
      yearsToFireHelp: "מספר השנים עד שתגיע למספר ה-FIRE",
      successProbability: "הסתברות הצלחה",
      successProbabilityHelp: "הסיכוי שהתיק יחזיק עד סוף תוחלת החיים",
      weightedReturn: "תשואה משוקללת",
      weightedReturnHelp: "התשואה השנתית המשוקללת לפי הרכב התיק",
    },
    chartView: {
      projectionChart: "גרף תחזית",
      assetMap: "מפת נכסים",
      fullscreen: "מסך מלא",
      exitFullscreen: "יציאה ממסך מלא",
      totalPortfolio: "סה״כ תיק",
      age: "גיל",
      speed: "מהירות",
      projection: "תחזית",
      earlyRetirement: "פרישה מוקדמת",
      pension: "פנסיה",
      now: "כיום",
      inOneYear: "עוד שנה",
      inYearsPrefix: "עוד",
      yearsSuffix: "שנים",
      eventsCount: "אירועים",
      moreEvents: "נוספים",
      normalView: "לתצוגה רגילה",
      durationView: "לתצוגת משך האירועים",
      zoomIn: "הגדל זום",
      zoomOut: "הקטן זום",
      zoom: "זום",
      viewMenu: "תצוגה",
      shrinkEvents: "כווץ אירועים",
      expandEvents: "הרחב אירועים",
      showLines: "הצג קווים",
      hideLines: "הסתר קווים",
      // Asset Map (sunburst) labels
      noAssetsInYear: "אין נכסים בשנה",
      returnsAndIncome: "תשואות + הכנסות",
      monthlyIncome: "הכנסה חודשית",
      monthlyWithdrawal: "משיכה חודשית",
      monthlyExpenses: "הוצאות חודשיות",
      netCashflow: "תזרים נטו",
      monthlySavings: "חיסכון חודשי",
      resetZoom: "איפוס",
      // Income & Expenses chart
      cashflowChart: "הכנסות והוצאות (חודשי)",
      cashflowChartTab: "הכנסות והוצאות",
      salaryIncome: "הכנסה ממשכורת",
      pensionIncome: "הכנסה מפנסיה",
      eventIncome: "הכנסה מאירועים",
      investReturns: "תשואות השקעה",
      livingExpenses: "הוצאות מחיה",
      eventExpenses: "הוצאות מאירועים",
      pensionTax: "מס פנסיה",
      totalAssets: "סה״כ נכסים",
      income: "הכנסות",
      expenses: "הוצאות",
      surplus: "עודף",
      deficit: "גירעון",
      primaryPartner: "בן/בת זוג ראשי",
      secondPartner: "בן/בת זוג",
    },
    events: {
      title: "אירועי חיים",
      subtitle: "הוסף אירועים שישפיעו על התחזית",
      // Scenarios
      addScenario: "תרחיש חדש",
      addScenarioWithAI: "תרחיש עם AI",
      deleteScenario: "מחק תרחיש",
      deleteScenarioConfirm: "למחוק את התרחיש?",
      renameScenario: "שנה שם",
      scenarioActive: "פעיל",
      scenarioName: "שם התרחיש",
      defaultScenarioName: "תרחיש חדש",
      eventsInScenario: "אירועים בתרחיש",
      eventsCount: "אירועים",
      // Events
      add: "הוסף אירוע",
      edit: "ערוך",
      save: "שמור",
      cancel: "ביטול",
      delete: "מחק",
      addEventType: "סוג אירוע",
      cashflowEvent: "הכנסה/הוצאה",
      buyAssetEvent: "רכישת נכס",
      sellAssetEvent: "מכירת נכס",
      loanEvent: "הלוואה",
      name: "שם האירוע",
      amount: "סכום",
      startYear: "שנה",
      endYear: "שנת סיום",
      endYearMode: "נגמר ב",
      endYearSpecific: "שנה ספציפית",
      endYearRetirement: "פרישה",
      endYearPension: "גיל פנסיה",
      endYearLifeExpectancy: "תוחלת חיים",
      frequency: "תדירות",
      direction: "כיוון",
      oneTime: "חד פעמי",
      monthly: "חודשי",
      yearly: "שנתי",
      inflow: "הכנסה",
      outflow: "הוצאה",
      category: "קטגוריה",
      investFrom: "מקור המימון",
      investFromCashflow: "מחיסכון שוטף",
      investFromCashflowHelp: "יקוזז מהחיסכון החודשי",
      investFromExtra: "כסף נוסף",
      investFromExtraHelp: "מתנה/בונוס - לא יקוזז מחיסכון",
      investFromBuyingCredit: "מקרדיט רכישה",
      investFromBuyingCreditHelp: "ישתמש בקרדיט שנצבר ממכירות וחיסכון",
      sellType: "סוג מכירה",
      sellTypeAmount: "סכום קבוע",
      sellTypePercentage: "אחוז מהנכס",
      sellAmount: "סכום למכירה",
      sellPercentage: "אחוז למכירה",
      selectProduct: "בחר נכס",
      allProductsInCategory: "כל הנכסים בקטגוריה (יחסי)",
      specificProduct: "נכס ספציפי",
      boughtAssetTag: "רכישה מתוכננת",
      currentValue: "שווי נוכחי",
      buyingCredit: "קרדיט רכישה",
      buyingCreditHelp: "קרדיט רכישה = יתרת מזומן (מחיסכון, מכירות, הכנסות)",
      availableCredit: "קרדיט זמין",
      insufficientCredit: "אין מספיק קרדיט - נסה למכור נכס קודם",
      insufficientCreditRecurring: "אין מספיק קרדיט לכל תקופת האירוע",
      insufficientCreditForExpense:
        "אין מספיק כסף בתיק למימון ההוצאה - נסה למכור נכס קודם",
      insufficientCreditForExpenseRecurring:
        "אין מספיק כסף בתיק למימון ההוצאה לכל תקופתה",
      missingAmount: "חסר",
      portfolioValueInYear: "שווי תיק בשנה",
      availableInCategory: "זמין בקטגוריה",
      creditInYear: "קרדיט בשנה",
      categoryBalanceInYear: "שווי צפוי בשנה",
      selectYear: "בחר שנה",
      assetTimeline: "תצוגת נכסים",
      totalPortfolio: "סה״כ תיק",
      play: "הפעל",
      pause: "עצור",
      speed: "מהירות",
      amountToSell: "סכום למכירה",
      iconLabel: "סמל",
      iconNone: "ללא סמל",
      noEvents: "אין אירועי חיים",
      noEventsSubtitle: 'לחץ על "הוסף אירוע" כדי להוסיף.',
      type: "סוג",
      // Subtype for recurring cashflow events
      eventSubtype: "סוג האירוע",
      subtypeReduceIncome: "הפחתת הכנסה",
      subtypeDebtRepayment: "החזר חוב",
      subtypeIncreaseIncome: "הגדלת הכנסה",
      subtypeYield: "תשואה",
      subtypeReduceExpenses: "הקטנת הוצאות",
      subtypeOther: "אחר",
      // Owner of an income event (couple mode)
      eventOwner: "למי שייך השינוי?",
      ownerPrimary: "בן/בת זוג ראשי",
      ownerPartner: "בן/בת זוג",
      ownerHousehold: "משק הבית",
      // Escalation for recurring cashflow events
      escalation: "שינוי שנתי",
      escalationHelp: "האם הסכום עולה או יורד מדי שנה?",
      escalationNone: "ללא שינוי",
      escalationPercentage: "אחוז",
      escalationFixed: "סכום קבוע",
      escalationRate: "שיעור שינוי שנתי (%)",
      escalationRateHelp:
        "חיובי = עליה, שלילי = ירידה. למשל: 3 = עליה של 3% בשנה",
      escalationAmount: "סכום שינוי שנתי",
      escalationAmountHelp:
        "חיובי = עליה, שלילי = ירידה. למשל: 500 = עליה של ₪500 בשנה",
      escalationPreview: "בשנה {year}: ₪{amount}",
      // Custom yield for buy events
      customYield: "תשואה מותאמת לרכישה",
      customYieldHelp: "הגדר תשואה ופרופיל סיכון מותאמים לנכס הנרכש",
      useCustomYield: "השתמש בתשואה מותאמת",
      useCategoryDefault: "השתמש בברירת מחדל של הקטגוריה",
      expectedReturn: "תשואה צפויה (%)",
      standardDeviation: "סטיית תקן (%)",
      riskProfile: "פרופיל סיכון",
      customProfileHint: "ליצירת פרופיל מותאם — עבור ללשונית ״הנחות תשואה״",
      // Loan event fields
      loanAmount: "סכום ההלוואה",
      loanInterestRate: "ריבית שנתית ממוצעת (%)",
      loanPeriodMonths: "תקופה (חודשים)",
      loanStartYear: "שנת התחלה",
      loanEndYear: "שנת סיום",
      loanTotalRepayment: "סה״כ החזר",
      loanMonthlyPayment: "החזר חודשי",
      loanPeriodHelp: "ניתן לשנות את מספר החודשים — שנת הסיום תתעדכן בהתאם",
      // Pension sell tax
      pensionTaxWarningTitle: "משיכה מוקדמת מפנסיה — חיוב מס 35%",
      pensionTaxWarningBody:
        "משיכה מוקדמת מכספי פנסיה (לפני גיל הזכאות) חייבת במס של 35% על הסכום הנמשך. הסכום הנטו (אחרי מס) יתווסף כנזילות לתיק.",
      pensionGrossAmount: "סכום ברוטו",
      pensionTax35: "מס משיכה מוקדמת (35%)",
      pensionNetProceeds: "נטו לאחר מס",
    },
    assumptions: {
      title: "הנחות תשואה וסיכון",
      subtitle: "התאם את הנחות התשואה לכל קטגוריית נכסים",
      category: "קטגוריה",
      return: "תשואה צפויה (%)",
      stddev: "סטיית תקן (%)",
      riskProfile: "פרופיל סיכון",
      manageProfiles: "ניהול פרופילי סיכון",
      cash: "מזומן",
      deposit: "פיקדונות וחסכונות",
      stocks: "מניות",
      crypto: "קריפטו",
      rsu: "RSU / אופציות",
      pension: "פנסיה",
      realestate: "נדל״ן",
      other: "אחר",
      debt: "הלוואות",
    },
    riskProfiles: {
      title: "ניהול פרופילי סיכון",
      subtitle: "פרופילי סיכון קובעים את טווח התנודתיות של התשואות בסימולציה",
      create: "צור פרופיל חדש",
      edit: "ערוך",
      duplicate: "שכפל",
      delete: "מחק",
      save: "שמור",
      cancel: "ביטול",
      name: "שם הפרופיל",
      downsideDelta: "ירידה מקסימלית מהממוצע (%)",
      upsideDelta: "עליה מקסימלית מהממוצע (%)",
      builtIn: "מובנה",
      custom: "מותאם אישית",
      readOnly: "פרופיל מובנה (קריאה בלבד)",
      inUse: "בשימוש",
      cannotDelete: "לא ניתן למחוק פרופיל שנמצא בשימוש",
      confirmDelete: "למחוק את הפרופיל?",
      nameRequired: "שם הפרופיל נדרש",
      deltaMustBePositive: "ערך חייב להיות חיובי",
      tooltipBadYear: "שנה גרועה טיפוסית (p5)",
      tooltipGoodYear: "שנה טובה טיפוסית (p95)",
      tooltipTruncated: "הסימולציה משתמשת בהתפלגות נורמלית חתוכה בגבולות אלה",
      migrationBanner: "מודל הסיכון שודרג לפרופילים — אנא בדוק את ההנחות שלך.",
      migrationDismiss: "הבנתי",
    },
    breakdown: {
      title: "פירוט נכסים",
      subtitle: "איך חושב התיק שלך",
      product: "מוצר",
      category: "קטגוריה",
      value: "שווי",
      ownership: "בעלות",
      liquid: "נזילות",
      included: "נכלל",
      totalAssets: "סה״כ נכסים",
      totalDebts: "סה״כ חובות",
      netWorth: "שווי נטו",
      liquidAssets: "נכסים נזילים",
      nonLiquidAssets: "נכסים לא נזילים",
      spendableBeforeRetirement: "זמין לפני פרישה",
      pensionLockedTitle: "פנסיה נעולה עד גיל פרישה",
      pensionLockedSubtitle: "יתווסף לתיק בגיל {age}",
      currentPension: "ערך נוכחי",
      expectedPension: "צפי בפרישה",
      monthlyContribution: "הפקדה חודשית",
      // Custom yield settings
      customYield: "תשואה מותאמת",
      customYieldHelp: "הגדר תשואה וסיכון מותאמים למוצר זה",
      useCustomYield: "השתמש בתשואה מותאמת",
      useCategoryDefault: "השתמש בברירת מחדל של הקטגוריה",
      expectedReturn: "תשואה צפויה",
      standardDeviation: "סטיית תקן",
      riskProfile: "פרופיל סיכון",
      hasCustomYield: "תשואה מותאמת",
      editCustomYield: "ערוך תשואה",
      clearCustomYield: "נקה תשואה מותאמת",
    },
    pensionTab: {
      title: "פירוט מוצרי פנסיה",
      subtitle: "ניהול מוצרי פנסיה והשלכות מס",
      totalMonthlyPension: "קצבה חודשית צפויה",
      totalLumpSum: "סכום חד-פעמי (הוני)",
      totalCurrentValue: "ערך נוכחי כולל",
      totalProjected: "ערך צפוי בפרישה",
      atRetirement: "בפרישה",
      perMonth: "לחודש",
      productClassLabel: "סוג מוצר",
      withdrawalTypeLabel: "סוג משיכה",
      mekademLabel: "מקדם",
      eligibilityAgeLabel: "גיל זכאות",
      currentValueLabel: "ערך נוכחי",
      projectedValueLabel: "ערך צפוי בפרישה",
      monthlyPensionLabel: "קצבה חודשית",
      lumpSumLabel: "סכום חד-פעמי",
      lumpSumTaxLabel: "מס על חלק הוני",
      monthlyContributionLabel: "הפקדה חודשית",
      maslekaProjectionLabel: "תחזית מסלקה",
      earlyWithdrawal: "משיכה מוקדמת",
      earlyWithdrawalToggle: "משוך מוצר זה (בגיל שנבחר)",
      withdrawAtAgeLabel: "גיל המשיכה (מעכשיו עד גיל זכאות)",
      accumulatedAtAgeLabel: "ערך צפוי בגיל {age}",
      earlyWithdrawalWarning: "משיכה מוקדמת חייבת במס 35% על מלוא הסכום",
      earlyWithdrawalTax: "מס משיכה מוקדמת (35%)",
      earlyWithdrawalNet: "נטו אחרי מס",
      earlyWithdrawalImpact: "הסכום יתווסף כנזיל לתיק ויוסר מתחזית הפנסיה",
      earlyKitzbaToggle: "התחל קצבה מוקדמת (בגיל שנבחר)",
      startKitzbaAtAgeLabel: "גיל תחילת הקצבה (מגיל 60 עד גיל זכאות)",
      earlyKitzbaExplanation:
        "משיכה מוקדמת כקצבה: כל שנה מוקדמת מגיל הפרישה הרשמי מעלה את המקדם ב-12, כך שהקצבה החודשית נמוכה יותר — אך מתחילה מוקדם יותר וללא מס 35%. מוקדם ב-{years} שנים.",
      earlyKitzbaMekademLabel: "מקדם מותאם",
      earlyKitzbaMonthlyGrossLabel: "קצבה חודשית (ברוטו)",
      earlyKitzbaMonthlyNetLabel: "קצבה חודשית (נטו)",
      kitzba: "קצבה",
      hon: "הוני",
      mixed: "מעורב",
      noProducts: "לא נמצאו מוצרי פנסיה",
      ownerLabel: "בעלים",
      filterByOwner: "סינון לפי בעלים",
      filterAll: "הכל",
      taxImplications: "השלכות מס",
      kitzbaTaxExemption: "פטור קצבה מזכה",
      kitzbaTaxNote: "עד {amount} ₪/חודש פטורים ממס ({percent}% פטור)",
      lumpSumTaxNote: "15% מס רווחי הון על הרווח בחלק ההוני",
      earlyTaxNote: "35% מס על מלוא הסכום במשיכה לפני גיל זכאות",
      summaryTitle: "סיכום פנסיה בפרישה",
      netMonthlyAfterTax: "קצבה חודשית נטו (אחרי מס)",
      excludedProducts: "מוצרים נזילים (לא כלולים בפנסיה)",
      // Pension Simulator
      simulatorTitle: "סימולטור פנסיה",
      simulatorSubtitle:
        "בדוק תרחישי פנסיה שונים — גיל יציאה לפנסיה, קצבה חודשית ומשיכה מוקדמת",
      pensionStartAge: "גיל תחילת פנסיה",
      pensionValueOverTime: "ערך הפנסיה לאורך זמן",
      monthlyPensionByAge: "קצבה חודשית לפי גיל תחילת פנסיה",
      scenarioComparison: "השוואת תרחישים",
      scenarioAge: "גיל",
      scenarioMonthly: "קצבה חודשית",
      scenarioMonthlyNet: "קצבה חודשית נטו",
      scenarioTotalValue: "ערך צפוי",
      scenarioCumulativeIncome: "הכנסה מצטברת עד גיל {life}",
      chartPensionValue: "ערך פנסיה",
      chartMonthlyPension: "קצבה חודשית (ברוטו)",
      chartMonthlyPensionNet: "קצבה חודשית (נטו)",
      chartEarlyWithdrawal: "משיכה מוקדמת (נטו אחרי 35% מס)",
      earlyPensionNote:
        "לפי החוק הישראלי ניתן להתחיל קבלת קצבה מגיל 60 עבור חלק מהמוצרים (קופות גמל הוניות, קופות להשקעה).",
      selectedAge: "גיל שנבחר: {age}",
      atAge: "בגיל {age}",
      tabValueOverTime: "ערך לאורך זמן",
      tabMonthlyByAge: "קצבה לפי גיל",
      tabDeposits: "הפקדות",
      tabContributionTable: "הפקדות ותשואה לפי שנה",
      tableYear: "שנה",
      tableAge: "גיל",
      tableContributionYear: "הפקדה בשנה",
      tableGrowth: "תשואה",
      tableValueEndOfYear: "ערך בסוף שנה",
      apply: "החל",
    },
    warnings: {
      title: "אזהרות",
    },
    buttons: {
      recalculate: "חשב מחדש",
      resetDefaults: "אפס להנחות ברירת מחדל",
      resetAllSettings: "אפס הכל",
      resetAllSettingsConfirm: "האם לאפס את כל ההגדרות?",
      reloadFromData: "טען מחדש מנתונים",
      moreActions: "פעולות נוספות",
      actions: "פעולות",
      lastSaved: "נשמר לאחרונה",
      newDataAvailable: "נתונים חדשים זמינים",
      exportExcel: "ייצוא לאקסל",
      exportExcelTooltip: "הורד תחזית פיננסית כקובץ Excel",
      exporting: "מייצא...",
      exportError: "שגיאה בייצוא",
      retirementGraphGuide: "מדריך לגרף הפרישה",
    },
    excel: {
      title: "תחזית פיננסית",
      subtitle: "Financial Projection",
      sheetName: "תחזית פרישה",
      userInfo: "פרטי משתמש",
      currentAge: "גיל נוכחי",
      retirementAge: "גיל פרישה",
      lifeExpectancy: "תוחלת חיים",
      withdrawalRate: "אחוז משיכה",
      monthlySpend: "הוצאות חודשיות",
      monthlyIncome: "הכנסה חודשית",
      monthlySavings: "חיסכון חודשי",
      ageRow: "גיל",
      yearRow: "שנה",
      // Income section
      incomeSection: "הכנסות",
      incomeImplied: "הכנסה חודשית (משכורת)",
      totalIncome: 'סה"כ הכנסות',
      // Expense section
      expenseSection: "הוצאות",
      monthlyExpenses: "הוצאות שוטפות",
      totalExpenses: 'סה"כ הוצאות',
      // Summary
      incomeMinusExpenses: "הכנסות פחות הוצאות",
      fireNumber: "מספר FIRE",
      fireNumberBy4: "לפי 4%",
      fireNumberBy3: "לפי 3.3%",
      surplusDeficit: "עודף / גירעון מצטבר",
      // Assets section
      assetsSection: "נכסים",
      assetCurrentValue: "ערך נוכחי",
      assetReturn: "תשואה",
      totalAssets: 'סה"כ נכסים',
      liquidAssets: "מתוכם נזילים",
      lockedPension: "פנסיה נעולה",
      // Liabilities section
      liabilitiesSection: "התחייבויות והוצאות חד פעמיות",
      totalLiabilities: 'סה"כ התחייבויות',
      // Net
      netAssets: 'סה"כ נכסים פחות התחייבויות',
      // Footer
      poweredBy: "Powered by Moneytor",
      generatedAt: "נוצר ב-",
    },
    monteCarloSettings: {
      simulations: "מספר סימולציות",
      simulationsHelp: "יותר סימולציות = תוצאות מדויקות יותר (אבל יותר איטי)",
    },
    goals: {
      tabTitle: "יעדים",
      title: "יעדי פרישה",
      subtitle: "הגדר יעדים פיננסיים ובדוק את הסיכוי להשיג אותם",
      add: "הוסף יעד",
      edit: "ערוך",
      save: "שמור",
      cancel: "ביטול",
      delete: "מחק",
      enabled: "פעיל",
      disabled: "מושבת",
      goalName: "שם היעד",
      targetAmount: "סכום יעד",
      targetAmountHelp: "הסכום שאתה רוצה להגיע אליו",
      targetAge: "גיל יעד",
      targetAgeHelp: "הגיל בו אתה רוצה להשיג את היעד",
      // Goal kind labels
      kindPortfolioTarget: "יעד תיק",
      kindPortfolioTargetDesc: "צבור סכום מסוים עד גיל מסוים",
      kindPortfolioSurvives: "שרידות תיק",
      kindPortfolioSurvivesDesc: "הכסף לא ייגמר עד תוחלת החיים",
      kindFireByAge: "FIRE עד גיל",
      kindFireByAgeDesc: "הגע לעצמאות כלכלית עד גיל מסוים",
      kindMinimumFloor: "רצפת ביטחון",
      kindMinimumFloorDesc: "התיק לעולם לא ירד מתחת לסכום מסוים",
      kindPurchaseGoal: "רכישה עתידית",
      kindPurchaseGoalDesc: "קנה נכס בגיל מסוים — הסכום ירד מהתיק",
      // Default goal names
      defaultSurvive: "שרידות עד תוחלת חיים",
      defaultBuyHome: "רכישת דירה",
      defaultFireByAge: "עצמאות כלכלית",
      defaultMinFloor: "רצפת ביטחון",
      defaultPurchase: "רכישת דירה",
      // Results
      overallSuccess: "סיכוי להשיג את כל היעדים",
      goalSuccess: "סיכוי הצלחה",
      deterministicMet: "מושג בתחזית",
      deterministicNotMet: "לא מושג בתחזית",
      metAtAge: "מושג בגיל",
      noGoals: "לא הוגדרו יעדים",
      noGoalsSubtitle: "הוסף יעד כדי לראות את הסיכוי להשיג אותו",
      // Presets
      presets: "יעדים מוכנים",
      addFromPreset: "הוסף מתבנית",
    },
    aiChat: {
      title: "תכנון עם AI",
      subtitle: "ספר/י על התוכניות שלך והבינה המלאכותית תיצור תרחיש מותאם",
      placeholder:
        "ספר/י על התוכניות שלך... למשל: אני רוצה לקנות דירה בעוד 5 שנים, לשלוח את הילדים ללימודים...",
      send: "שלח",
      apply: "החל תרחיש",
      applyAndClose: "החל וסגור",
      preview: "תצוגה מקדימה",
      generating: "יוצר תרחיש...",
      error: "שגיאה ביצירת תרחיש",
      errorRetry: "נסה שוב",
      close: "סגור",
      eventsPreview: "אירועי חיים",
      goalsPreview: "יעדים",
      scenarioName: "שם התרחיש",
      noEventsGenerated: "לא נוצרו אירועים",
      noGoalsGenerated: "לא נוצרו יעדים",
      appliedSuccess: "התרחיש הוחל בהצלחה!",
      suggestedRetirementAge: "גיל פרישה מומלץ",
      acceptSuggestion: "קבל",
      openButton: "תכנון עם AI",
      openButtonTooltip:
        "ספר/י על התוכניות שלך והבינה המלאכותית תיצור תרחיש מותאם",
      newChat: "שיחה חדשה",
      eventCount: "אירועים",
      goalCount: "יעדים",
      voiceListening: "מקשיב...",
      voiceTapToSpeak: "לחצ/י לדיבור",
      voiceTapToStop: "לחצ/י לעצירה ושליחה",
      voiceNotSupported: "דיבור אינו נתמך בדפדפן זה",
      direction: {
        inflow: "הכנסה",
        outflow: "הוצאה",
      },
      frequency: {
        oneTime: "חד פעמי",
        monthly: "חודשי",
        yearly: "שנתי",
      },
    },
    ui: {
      eventTypes: {
        buy: "קנייה",
        sell: "מכירה",
        loan: "הלוואה",
      },
      lifeEventIcons: {
        home: "בית",
        car: "רכב",
        school: "לימודים",
        baby: "תינוק",
        family: "משפחה",
        flight: "טיסה / חופשה",
        work: "עבודה",
        medical: "רפואה",
        celebration: "חגיגה / חתונה",
        gift: "מתנה",
        restaurant: "מסעדות / אוכל",
        fitness: "ספורט / בריאות",
        pets: "חיות מחמד",
        renovation: "שיפוץ",
        laptop: "טכנולוגיה",
        trendingUp: "העלאה / צמיחה",
        trendingDown: "הפחתה / ירידה",
        savings: "חיסכון",
        beach: "פרישה / חופש",
        donate: "תרומה",
        bank: "בנק / הלוואה",
        shopping: "קניות",
      },
    },
    help: {
      fire: {
        title: "🔥 מה זה FIRE?",
        p1Text:
          "(Financial Independence, Retire Early) הוא תנועה פיננסית שמטרתה להגיע לעצמאות כלכלית — המצב שבו יש לך מספיק נכסים כדי לכסות את ההוצאות שלך לכל החיים, מבלי לעבוד. זה לא בהכרח אומר להפסיק לעבוד — אלא שלעבוד הופך",
        p1Choice: "לבחירה",
        p1Separator: " ולא ",
        p1Necessity: "להכרח",
        p2Text:
          "הרעיון פשוט: צברו מספיק כסף שהתשואה השנתית שלו תכסה את ההוצאות שלכם. הסכום הזה נקרא",
        p2FireNumber: "מספר ה-FIRE",
      },
      goals: {
        title: "🎯 יעדי פרישה",
        introTitle: "מהם יעדי פרישה?",
        introDesc:
          "במקום להסתכל רק על מספר FIRE יחיד, המחשבון מאפשר להגדיר יעדים אישיים שמשקפים את המטרות הפיננסיות שלכם. לכל יעד מחושבת הסתברות הצלחה נפרדת.",
        typesTitle: "סוגי יעדים",
        typePortfolioSurvivesTitle: "🏖️ שרידות תיק",
        typePortfolioSurvivesDesc:
          "היעד הבסיסי ביותר — שהכסף לא ייגמר עד תוחלת החיים. המחשבון בודק כמה מתרחישי הסימולציה מסתיימים עם תיק חיובי.",
        typePortfolioTargetTitle: "🏠 יעד סכום בגיל מסוים",
        typePortfolioTargetDesc:
          "רוצים להגיע ל-₪X עד גיל Y? לדוגמה: ₪2,000,000 עד גיל 55 לרכישת דירה. המחשבון בודק באיזה אחוז מהתרחישים התיק הגיע לסכום הזה.",
        typePurchaseTitle: "🛒 רכישה עתידית",
        typePurchaseDesc:
          "תכננו הוצאה גדולה בגיל מסוים (דירה, רכב, חתונה). היעד הזה בודק אם התיק יכול לממן את הרכישה, ויוצר אוטומטית אירוע חיים של הוצאה שמורידה את הסכום מהתיק.",
        typeFireByAgeTitle: "📈 FIRE עד גיל",
        typeFireByAgeDesc:
          "להגיע לעצמאות כלכלית (מספר FIRE) עד גיל מסוים. המחשבון בודק באיזה אחוז מהתרחישים הגעתם ליעד.",
        typeMinFloorTitle: "💰 רצפה מינימלית",
        typeMinFloorDesc:
          "שמירה על סכום מינימלי בתיק לכל אורך הפרישה, למשל ₪500,000 כרשת ביטחון. המחשבון בודק שהתיק לא ירד מתחת לסכום הזה.",
        howItWorksTitle: "איך זה עובד?",
        howItWorksDesc:
          "כל יעד מקבל אחוז הצלחה בנפרד — הסתברות שהתרחיש מתקיים מתוך כל סימולציות ה-Monte Carlo. בנוסף, מוצג אחוז הצלחה כולל — הסיכוי להשיג את כל היעדים יחד.",
        tipsTitle: "טיפים",
        tip1: "התחילו עם יעד שרידות תיק בסיסי — זה היעד הכי חשוב",
        tip2: "הוסיפו יעדי רכישה לתכנון הוצאות גדולות (הם יוצרים אירועי חיים אוטומטית)",
        tip3: "ניתן להפעיל/לכבות יעדים כדי לבדוק איך הם משפיעים על ההסתברות הכוללת",
        tip4: "שאפו לאחוז הצלחה מעל 80% לכל יעד",
      },
      keyNumbers: {
        title: "📊 המספרים שמופיעים מעל הגרף",
        fireNumberTitle: "מספר FIRE — כמה כסף צריך?",
        fireNumberDesc:
          "הסכום הכולל שצריך לצבור כדי לפרוש. מחושב כ: הוצאות שנתיות ÷ אחוז משיכה.",
        fireNumberExample:
          "לדוגמה: אם ההוצאות החודשיות הן ₪15,000 (₪180,000 בשנה) ואחוז המשיכה 4%, מספר ה-FIRE הוא",
        fireNumberExampleValue: "₪4,500,000",
        yearsTitle: "שנים עד FIRE — מתי אפשר לפרוש?",
        yearsDesc:
          "מספר השנים שייקח לצבור את מספר ה-FIRE, בהתבסס על התיק הנוכחי, החיסכון החודשי, והתשואות הצפויות. אם המספר גבוה מדי — אפשר לנסות להגדיל חיסכון, להקטין הוצאות, או לבחון אחוז משיכה גבוה יותר.",
        successTitle: "הסתברות הצלחה — כמה בטוח זה?",
        successDesc:
          "מופיע כשסימולציית Monte Carlo מופעלת. מייצג את אחוז התרחישים שבהם הכסף לא נגמר עד סוף תוחלת החיים.",
        successThresholds: "מעל 80% נחשב טוב, מעל 90% נחשב מצוין.",
      },
      withdrawalRate: {
        title: "💰 אחוז משיכה — המושג הכי חשוב ב-FIRE",
        p1Label: "אחוז המשיכה",
        p1Text:
          "הוא האחוז שאתם מושכים מהתיק כל שנה לכיסוי הוצאות. הוא קובע כמה כסף תצטרכו לצבור (מספר FIRE = הוצאות שנתיות ÷ אחוז משיכה).",
        p2Label: "כלל 4%:",
        p2Text:
          "המחקר הידוע (Trinity Study) מצא שמשיכה של 4% בשנה מתיק מניות ואגרות חוב שרדה כמעט את כל התקופות ההיסטוריות (30 שנה+) בשוק האמריקאי.",
        examplesTitle: "דוגמאות — הוצאות חודשיות של ₪15,000 (₪180,000 בשנה):",
        colWithdrawalRate: "אחוז משיכה",
        colFireNumber: "מספר FIRE",
        colConfidence: "רמת ביטחון",
        colSuitableFor: "מתאים ל...",
        row3Confidence: "גבוהה מאוד",
        row3Suitable: "פרישה מוקדמת (30+ שנה), שמרנים",
        row4Confidence: "גבוהה",
        row4Suitable: "ברירת מחדל מומלצת, פרישה רגילה",
        row5Confidence: "בינונית",
        row5Suitable: "פרישה מאוחרת, הכנסה נוספת (פנסיה, שכירות)",
        row6Confidence: "נמוכה יותר",
        row6Suitable: "יש הכנסה קבועה נוספת משמעותית",
        footerText:
          "ככל שאחוז המשיכה נמוך יותר, צריך לצבור יותר כסף — אבל הסיכוי שהכסף יחזיק לאורך זמן עולה משמעותית.",
      },
      calculator: {
        title: "🧮 מה המחשבון הזה מאפשר?",
        autoCalcLabel: "חישוב אוטומטי",
        autoCalcDesc:
          "טוען את כל הנכסים, ההוצאות וההכנסות שלכם ישירות מהנתונים במערכת",
        visualLabel: "תחזית ויזואלית",
        visualDesc: "גרף שמראה את צמיחת התיק לאורך השנים עד ואחרי הפרישה",
        monteCarloLabel: "סימולציית Monte Carlo",
        monteCarloDesc:
          "מאות תרחישים אקראיים שמראים את טווח התוצאות האפשריות ואת הסתברות ההצלחה",
        lifeEventsLabel: "אירועי חיים",
        lifeEventsDesc:
          "תכננו אירועים עתידיים (רכישת דירה, ירושה, לימודי ילדים) וראו איך הם משפיעים על התחזית",
        scenariosLabel: "תרחישים",
        scenariosDesc:
          "השוו בין תרחישים שונים (אופטימי, פסימי) כדי לקבל החלטות מושכלות",
        goalsLabel: "יעדים אישיים",
        goalsDesc:
          "הגדירו יעדי פרישה (שרידות תיק, רכישות עתידיות, FIRE) וראו את הסיכוי להשיג כל אחד",
        customLabel: "התאמה מלאה",
        customDesc:
          "שנו הנחות תשואה, פרופילי סיכון, וכללו/הסירו נכסים לפי הצורך",
      },
      graphElements: {
        title: "📊 מה מוצג בגרף",
        projectionTitle: "קו התחזית (כחול)",
        projectionDesc:
          "תחזית דטרמיניסטית של שווי התיק שלך לאורך השנים. מבוססת על הנחות התשואה שהגדרת לכל קטגוריית נכסים.",
        monteCarloBandsTitle: "רצועות Monte Carlo",
        p90Label: "P90 (ירוק)",
        p90Desc: "תרחיש אופטימי (10% מהסימולציות הגיעו לתוצאה טובה יותר)",
        p50Label: "P50 (כתום)",
        p50Desc: "חציון (50% מהסימולציות היו מעל/מתחת)",
        p10Label: "P10 (אדום)",
        p10Desc: "תרחיש פסימי (90% מהסימולציות הגיעו לתוצאה טובה יותר)",
        fireLineTitle: "קו FIRE (ירוק מקווקו)",
        fireLineDesc:
          "הסכום שאתה צריך כדי לפרוש. מחושב כ: הוצאות שנתיות ÷ אחוז משיכה בטוח.",
        fireLineExample:
          "לדוגמה: אם ההוצאות החודשיות הן ₪20,000 ואחוז המשיכה 4%, מספר ה-FIRE הוא ₪6,000,000.",
        retirementLineTitle: "קו פרישה (כחול מקווקו)",
        retirementLineDesc:
          "הגיל בו אתה מתכנן להפסיק לעבוד. מרגע זה, במקום להוסיף חיסכון - מתחילים למשוך מהתיק.",
      },
      calculation: {
        title: "🧮 איך מחושבת התחזית",
        accumulationTitle: "שלב הצבירה (לפני פרישה)",
        accumulationItem1:
          'החיסכון החודשי נצבר כ"קרדיט רכישה" (לא מושקע אוטומטית)',
        accumulationItem2:
          "הנכסים הקיימים צומחים לפי התשואה שהוגדרה לכל קטגוריה",
        accumulationItem3:
          "אירועי חיים (רכישות, מכירות, הכנסות) משפיעים על התיק",
        withdrawalTitle: "שלב המשיכה (אחרי פרישה)",
        withdrawalItem1:
          "כל שנה נמשכות ההוצאות החודשיות × 12, מותאמות לאינפלציה",
        withdrawalItem2Label: "חשוב:",
        withdrawalItem2Text:
          "המשיכה מבוססת על ההוצאות בפועל, לא על אחוז המשיכה",
        withdrawalItem3: "הנכסים ממשיכים לצמוח בניכוי המשיכות",
        inflationTitle: "התאמה לאינפלציה",
        inflationDesc:
          "כל הסכומים (הוצאות, משיכות) מותאמים לאינפלציה שהוגדרה. אם ההוצאות היום הן ₪15,000 והאינפלציה 2%, בעוד 10 שנים הן יהיו ₪18,285.",
      },
      pension: {
        title: "🏦 פנסיה",
        whenTitle: "מתי הפנסיה מתווספת?",
        whenDesc: "הפנסיה נעולה עד גיל הזכאות החוקי:",
        whenForMales: "לגברים,",
        whenForFemales: "לנשים",
        whenEarlyRetirement:
          "גם אם תפרוש מוקדם יותר, הפנסיה תתווסף רק בגיל הזכאות.",
        includedTitle: "מה נכלל בחישוב הפנסיה?",
        includedItem1: "הערך הנוכחי של קרנות הפנסיה",
        includedItem2: "ההפקדות העתידיות (עובד + מעסיק) עד גיל הזכאות",
        includedItem3: "תשואה צפויה (כ-4.3% שנתי)",
        includedItem4: "דמי ניהול (מהפקדה ומצבירה)",
        excludedLabel: "לא כולל:",
        excludedText: "קרנות השתלמות (נזילות לפני פנסיה)",
        graphTitle: "בגרף",
        graphDesc:
          "בגיל הזכאות לפנסיה, מוצרי קצבה מתחילים לספק הכנסה חודשית קבועה שמפחיתה את המשיכות מהתיק. מוצרים הוניים מתווספים כסכום חד-פעמי לתיק.",
      },
      pensionLaw: {
        title: "📋 חוקי פנסיה ישראליים",
        productTypesTitle: "סוגי מוצרים פנסיוניים",
        productTypesDesc: "כל מוצר פנסיוני מתנהג אחרת בפרישה:",
        kerenPensiaTitle: "קרן פנסיה (קצבתי)",
        kerenPensiaDesc:
          "המוצר הנפוץ ביותר. הצבירה מומרת לקצבה חודשית בפרישה באמצעות מקדם המרה. כולל ביטוח נכות ושאירים.",
        bituachMenahalimTitle: "ביטוח מנהלים",
        bituachMenahalimDesc:
          "פוליסת ביטוח חיים הכוללת חיסכון. ניתן לפדות כקצבה, כסכום חד-פעמי (הון), או שילוב של שניהם. כולל ביטוח נכות ושאירים.",
        kupatGemelKitzbatitTitle: "קופת גמל (קצבתי, מ-2008)",
        kupatGemelKitzbatitDesc:
          "הפקדות מ-2008 ואילך מיועדות לקצבה בלבד ולא ניתן לפדות כסכום חד-פעמי.",
        kupatGemelHonitTitle: "קופת גמל (הוני, לפני 2008)",
        kupatGemelHonitDesc:
          "הפקדות שהופקדו לפני 2008 ניתנות לפדיון כסכום חד-פעמי פטור ממס מגיל 60.",
        kupatGemelLehashkaaTitle: "קופת גמל להשקעה",
        kupatGemelLehashkaaDesc:
          "ניתנת לפדיון מגיל 60 כסכום חד-פעמי (מס רווח הון 15%) או כקצבה פטורה ממס. תקרת הפקדה שנתית כ-82,000 ₪.",
        kerenHishtalmutTitle: "קרן השתלמות",
        kerenHishtalmutDesc:
          "נזילה לאחר 6 שנות ותק, פטורה ממס. אינה מוצר פנסיוני — מוצגת בקטגוריית 'אחר' ואינה נעולה עד הפרישה.",

        mekademTitle: "מקדם המרה (מקדם)",
        mekademDesc: "המקדם קובע כמה קצבה חודשית תקבל מהחיסכון שצברת:",
        mekademFormula: "קצבה חודשית = סך הצבירה ÷ מקדם",
        mekademExample:
          "לדוגמה: צבירה של 1,000,000 ₪ ÷ מקדם 220 = 4,545 ₪ לחודש",
        mekademFactorsTitle: "מה משפיע על המקדם?",
        mekademFactor1:
          "גיל פרישה — מקדם נמוך יותר (יותר קצבה) ככל שפורשים מאוחר יותר",
        mekademFactor2:
          "מין — מקדם גבוה יותר (פחות קצבה) לנשים בשל תוחלת חיים ארוכה יותר",
        mekademFactor3: "מצב משפחתי — מקדם גבוה יותר לנשואים בשל פנסיית שאירים",
        mekademSourceTitle: "מקור המקדם",
        mekademSourceDesc:
          "אם יש מקדם מובטח בנתוני המסלקה, המחשבון ישתמש בו. אחרת, נשתמש בטבלה אקטוארית ברירת מחדל.",

        taxTitle: "מיסוי פנסיה",
        taxKitzbaTitle: "קצבה חודשית בפרישה",
        taxKitzbaDesc:
          "קצבה מזכה (עד 9,430 ₪ לחודש) פטורה ממס בשיעור הולך וגדל: 57% ב-2025, 60% ב-2026, ועד 67% ב-2028. החלק שמעל הפטור ממוסה במס שולי.",
        taxLumpSumTitle: "פדיון חד-פעמי (הון)",
        taxLumpSumDesc:
          "תיקון 190: מס רווח הון 15% ריאלי על הרווח בלבד (לעומת 25% בשוק ההון).",
        taxEarlyTitle: "משיכה מוקדמת (לפני גיל פרישה)",
        taxEarlyDesc:
          "מס קבוע של 35% על כל סכום המשיכה. לא ניתן לקזז (למעט חריגים כמו נכות או מחלה).",

        contributionsTitle: "השפעת הכנסה על הפקדות",
        contributionsDesc:
          "הפקדות לפנסיה הן אחוז מהשכר (6% עובד + 6.5% מעסיק + 6-8.33% פיצויים). כאשר ההכנסה יורדת (מעבר למשרה חלקית, פרישה מוקדמת) — ההפקדות יורדות ביחס, מה שמקטין את הצבירה הצפויה בפרישה.",
        contributionsRetirement: "בפרישה, ההפקדות מפסיקות לגמרי.",

        pitzuimTitle: "פיצויים",
        pitzuimDesc:
          "כ-40% מהצבירה הפנסיונית מגיעה מהפקדות פיצויים של המעסיק. משיכה מוקדמת של פיצויים מקטינה משמעותית את הקצבה העתידית.",

        retirementAgeTitle: "גיל פרישה",
        retirementAgeDesc:
          "גיל הזכאות לפנסיה: 67 לגברים, 65 לנשים. פרישה מוקדמת אפשרית אך ללא קצבה עד גיל הזכאות — צריך לממן את התקופה שביניהם מהתיק הנזיל.",
      },
      monteCarlo: {
        title: "🎲 סימולציית Monte Carlo",
        whatTitle: "מה זה?",
        whatDesc:
          "במקום להניח תשואה קבועה, הסימולציה מריצה מאות תרחישים אקראיים. לכל קטגוריית נכסים מוגדר פרופיל סיכון שקובע את טווח התנודות — הסימולציה מגרילה תשואה שנתית אקראית בטווח הזה בכל שנה.",
        successTitle: "הסתברות הצלחה",
        successDesc: "אחוז הסימולציות שבהן התיק לא נגמר עד סוף תוחלת החיים.",
        successAbove90: "מעל 90% - מצוין",
        success75to90: "75-90% - טוב",
        successBelow75: "מתחת ל-75% - כדאי לשקול הגדלת חיסכון או הורדת הוצאות",
        whyTitle: "למה זה חשוב?",
        whyDesc:
          "השוק לא עולה בקצב קבוע. יכולות להיות שנים טובות (20%+) ושנים רעות (-30%). Monte Carlo עוזר להבין את טווח התוצאות האפשריות.",
      },
      riskProfilesHelp: {
        title: "🎯 פרופילי סיכון",
        whatTitle: "מה זה פרופיל סיכון?",
        whatDesc:
          "פרופיל סיכון מגדיר את טווח התנודתיות של התשואות בסימולציה. במקום להזין סטיית תקן ידנית, בוחרים פרופיל שמתאר את עוצמת התנודות — כמה הנכס עלול לרדת בשנה גרועה וכמה הוא עשוי לעלות בשנה טובה.",
        howTitle: "איך זה עובד?",
        howDesc: "לכל פרופיל מוגדרים שני מספרים:",
        howP5Label: "ירידה מקסימלית טיפוסית (p5)",
        howP5Desc:
          "בשנה גרועה (אחת מ-20), התשואה תרד בערך במספר הזה מתחת לממוצע",
        howP95Label: "עלייה מקסימלית טיפוסית (p95)",
        howP95Desc:
          "בשנה טובה (אחת מ-20), התשואה תעלה בערך במספר הזה מעל הממוצע",
        howDistribution:
          "הסימולציה משתמשת בהתפלגות נורמלית חתוכה בגבולות האלה כדי לייצר תשואות אקראיות ריאליסטיות.",
        examplesTitle: "דוגמאות מעשיות",
        exBankTitle: '🏦 פיקדון בנקאי — פרופיל "שמרני" (↓3% / ↑5%)',
        exBankStats: "תשואה צפויה: 3% | שנה גרועה: 0% | שנה טובה: 8%",
        exBankDesc:
          "תיק של ₪500,000 — ברוב השנים תרוויחו ₪10,000-₪40,000. כמעט אין סיכון להפסד.",
        exStocksTitle: '📈 מדד S&P 500 — פרופיל "צמיחה" (↓20% / ↑30%)',
        exStocksStats: "תשואה צפויה: 7% | שנה גרועה: -13% | שנה טובה: 37%",
        exStocksDesc:
          "תיק של ₪500,000 — בשנה טובה אפשר להרוויח ₪185,000, אבל בשנה גרועה אפשר להפסיד ₪65,000.",
        exCryptoTitle: '₿ קריפטו — פרופיל "ספקולטיבי" (↓40% / ↑75%)',
        exCryptoStats: "תשואה צפויה: 10% | שנה גרועה: -30% | שנה טובה: 85%",
        exCryptoDesc:
          "תיק של ₪500,000 — עלול לרדת ל-₪350,000 בשנה גרועה, אבל גם לקפוץ ל-₪925,000 בשנה טובה.",
        defaultsTitle: "ברירות מחדל לפי קטגוריה",
        defaultsDesc: "לכל קטגוריית נכסים מותאם אוטומטית פרופיל סיכון מתאים:",
        defaultCash: "מזומן",
        defaultCashProfile: "שימור הון (תנודתיות מינימלית)",
        defaultDeposits: "פיקדונות",
        defaultDepositsProfile: "שמרני",
        defaultPension: "פנסיה",
        defaultPensionProfile: "מאוזן",
        defaultRealestate: 'נדל"ן',
        defaultRealestateProfile: "צמיחה מתונה",
        defaultStocks: "מניות",
        defaultStocksProfile: "צמיחה",
        defaultRsu: "RSU / אופציות",
        defaultRsuProfile: "אגרסיבי",
        defaultCrypto: "קריפטו",
        defaultCryptoProfile: "ספקולטיבי",
        customTitle: "פרופילים מותאמים אישית",
        customDesc:
          'ניתן ליצור פרופילי סיכון מותאמים דרך כפתור "ניהול פרופילי סיכון" בלשונית',
        customDescTab: "הנחות תשואה",
        customExample:
          "לדוגמה: אם אתם משקיעים בקרן מנייתית שמרנית שמתנהגת אחרת ממדד ה-S&P, תוכלו ליצור פרופיל עם ↓12% / ↑18% שמתאר טוב יותר את התנהגות הקרן.",
      },
      lifeEvents: {
        title: "📅 אירועי חיים",
        typesTitle: "סוגי אירועים",
        typeIncomeExpenseLabel: "הכנסה/הוצאה",
        typeIncomeExpenseDesc: "כסף שנכנס או יוצא (ירושה, חתונה, לימודים)",
        typeBuyLabel: "רכישת נכס",
        typeBuyDesc: "השקעה בקטגוריה מסוימת",
        typeSellLabel: "מכירת נכס",
        typeSellDesc: "מימוש נכסים (מעביר לקרדיט רכישה)",
        creditTitle: "קרדיט רכישה",
        creditDesc: "כסף שנצבר ומחכה להשקעה. מורכב מ:",
        creditItem1: "חיסכון חודשי שלא הושקע",
        creditItem2: "תמורה ממכירת נכסים",
        creditItem3: "הכנסות חד-פעמיות",
        creditNote: "שים לב:",
        creditNoteText:
          "קרדיט רכישה לא צומח (0% תשואה) עד שמשתמשים בו לקנות נכס.",
      },
      tips: {
        title: "💡 טיפים",
        tip1: "עדכנו את ההוצאות החודשיות בצורה ריאלית - זה הנתון הקריטי ביותר",
        tip2: "הוסיפו אירועי חיים צפויים (לימודי ילדים, רכישת דירה, ירושה)",
        tip3: "השתמשו ב-Monte Carlo כדי לראות את טווח התוצאות האפשריות",
        tip4: "בדקו את הסתברות ההצלחה - שאפו למעל 80%",
        tip5Warning: "התחזית מבוססת על הנחות - המציאות עשויה להיות שונה",
      },
    },
  },
  ENG: {
    title: "Advanced Retirement Calculator",
    tabs: {
      inputs: "Basic Data",
      events: "Life Events",
      assumptions: "Return Assumptions",
      breakdown: "Asset Breakdown",
      pension: "Pension",
    },
    advancedSection: {
      title: "Advanced Settings",
      subtitle:
        "Withdrawal rates, inflation, return assumptions and asset breakdown",
      tabSettings: "Settings",
      tabReturns: "Returns & Risk",
      tabBreakdown: "Asset Breakdown",
    },
    inputs: {
      gender: "Gender",
      genderHelp:
        "Affects the legal retirement age (67 for male, 65 for female)",
      genderMale: "Male",
      genderFemale: "Female",
      currentAge: "Current Age",
      currentAgeHelp: "Your age today",
      retirementAge: "Planned Retirement Age",
      retirementAgeHelp: "The age at which you plan to stop working",
      lifeExpectancy: "Life Expectancy",
      lifeExpectancyHelp: "Expected life expectancy for budget calculation",
      monthlySpend: "Monthly Expenses",
      monthlySpendHelp: "The monthly expenses you expect in retirement",
      monthlyIncome: "Monthly Income",
      monthlyIncomeHelp:
        "Total net monthly income (including salary, additional income)",
      monthlySavings: "Monthly Savings",
      monthlySavingsHelp: "Automatically derived: income minus expenses",
      syncFromCashflow: "Calculate automatically from the last 6 months",
      coupleToggle: "Plan as a couple",
      coupleToggleHelp: "Split income between two partners, each with their own age, gender and retirement age",
      partner1: "Partner 1",
      partner2: "Partner 2",
      partnerIncome: "Monthly Income",
      householdIncome: "Household Income (total)",
      partnerGender: "Gender",
      partnerCurrentAge: "Current Age",
      partnerRetirementAge: "Retirement Age",
      withdrawalRate: "Withdrawal Rate (%)",
      withdrawalRateHelp:
        "Annual withdrawal rate from the portfolio (4% is considered safe)",
      inflation: "Inflation (%)",
      inflationHelp: "Expected annual inflation rate",
      startingPortfolio: "Starting Portfolio",
      startingPortfolioHelp: "Your current portfolio value",
    },
    toggles: {
      includeRealestate: "Include illiquid real estate",
      includeRealestateHelp:
        "Whether to include illiquid real estate in the investment portfolio",
      includePension: "Include pension before retirement age",
      includePensionHelp:
        "Whether to include pension funds before retirement age",
      includeUnvestedRSU: "Include unvested RSUs",
      includeUnvestedRSUHelp: "Whether to include unvested RSUs as life events",
      monteCarlo: "Enable Monte Carlo",
      monteCarloHelp:
        "Run a stochastic simulation to calculate success probability",
      advancedSettings: "Advanced Settings",
    },
    results: {
      fireNumber: "FIRE Number",
      fireNumberHelp: "The amount you need to retire early",
      yearsToFire: "Years to FIRE",
      yearsToFireHelp: "Number of years until you reach your FIRE number",
      successProbability: "Success Probability",
      successProbabilityHelp:
        "The chance that the portfolio lasts through life expectancy",
      weightedReturn: "Weighted Return",
      weightedReturnHelp:
        "The weighted annual return based on portfolio composition",
    },
    chartView: {
      projectionChart: "Projection Chart",
      assetMap: "Asset Map",
      fullscreen: "Full Screen",
      exitFullscreen: "Exit Full Screen",
      totalPortfolio: "Total Portfolio",
      age: "Age",
      speed: "Speed",
      projection: "Projection",
      earlyRetirement: "Early Retirement",
      pension: "Pension",
      now: "now",
      inOneYear: "in 1 year",
      inYearsPrefix: "in",
      yearsSuffix: "years",
      eventsCount: "events",
      moreEvents: "more",
      normalView: "Normal View",
      durationView: "Duration View",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      zoom: "Zoom",
      viewMenu: "View",
      shrinkEvents: "Shrink Events",
      expandEvents: "Expand Events",
      showLines: "Show Lines",
      hideLines: "Hide Lines",
      // Asset Map (sunburst) labels
      noAssetsInYear: "No assets in year",
      returnsAndIncome: "Returns + Income",
      monthlyIncome: "Monthly Income",
      monthlyWithdrawal: "Monthly Withdrawal",
      monthlyExpenses: "Monthly Expenses",
      netCashflow: "Net Cash Flow",
      monthlySavings: "Monthly Savings",
      resetZoom: "Reset",
      // Income & Expenses chart
      cashflowChart: "Income & Expenses (Monthly)",
      cashflowChartTab: "Income & Expenses",
      salaryIncome: "Salary Income",
      pensionIncome: "Pension Income",
      eventIncome: "Event Income",
      investReturns: "Investment Returns",
      livingExpenses: "Living Expenses",
      eventExpenses: "Event Expenses",
      pensionTax: "Pension Tax",
      totalAssets: "Total Assets",
      income: "Income",
      expenses: "Expenses",
      surplus: "Surplus",
      deficit: "Deficit",
      primaryPartner: "Primary partner",
      secondPartner: "Partner",
    },
    events: {
      title: "Life Events",
      subtitle: "Add events that will affect the projection",
      addScenario: "New Scenario",
      addScenarioWithAI: "Scenario with AI",
      deleteScenario: "Delete Scenario",
      deleteScenarioConfirm: "Delete this scenario?",
      renameScenario: "Rename",
      scenarioActive: "Active",
      scenarioName: "Scenario Name",
      defaultScenarioName: "New Scenario",
      eventsInScenario: "Events in",
      eventsCount: "events",
      add: "Add Event",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      addEventType: "Event Type",
      cashflowEvent: "Income/Expense",
      buyAssetEvent: "Buy Asset",
      sellAssetEvent: "Sell Asset",
      loanEvent: "Loan",
      name: "Event Name",
      amount: "Amount",
      startYear: "Year",
      endYear: "End Year",
      endYearMode: "Ends at",
      endYearSpecific: "Specific Year",
      endYearRetirement: "Retirement",
      endYearPension: "Pension Age",
      endYearLifeExpectancy: "Life Expectancy",
      frequency: "Frequency",
      direction: "Direction",
      oneTime: "One-time",
      monthly: "Monthly",
      yearly: "Yearly",
      inflow: "Income",
      outflow: "Expense",
      category: "Category",
      investFrom: "Funding Source",
      investFromCashflow: "From Current Savings",
      investFromCashflowHelp: "Will be deducted from monthly savings",
      investFromExtra: "Extra Money",
      investFromExtraHelp: "Gift/bonus — will not be deducted from savings",
      investFromBuyingCredit: "From Buying Credit",
      investFromBuyingCreditHelp:
        "Will use credit accumulated from sales and savings",
      sellType: "Sale Type",
      sellTypeAmount: "Fixed Amount",
      sellTypePercentage: "Percentage of Asset",
      sellAmount: "Amount to Sell",
      sellPercentage: "Percentage to Sell",
      selectProduct: "Select Asset",
      allProductsInCategory: "All Assets in Category (proportional)",
      specificProduct: "Specific Asset",
      boughtAssetTag: "Planned Purchase",
      currentValue: "Current Value",
      buyingCredit: "Buying Credit",
      buyingCreditHelp:
        "Buying credit = cash balance (from savings, sales, income)",
      availableCredit: "Available Credit",
      insufficientCredit: "Insufficient credit — try selling an asset first",
      insufficientCreditRecurring:
        "Insufficient credit for the entire event period",
      insufficientCreditForExpense:
        "Insufficient portfolio funds to cover the expense — try selling an asset first",
      insufficientCreditForExpenseRecurring:
        "Insufficient portfolio funds to cover the expense for its full duration",
      missingAmount: "Missing",
      portfolioValueInYear: "Portfolio Value in Year",
      availableInCategory: "Available in Category",
      creditInYear: "Credit in Year",
      categoryBalanceInYear: "Expected Value in Year",
      selectYear: "Select Year",
      assetTimeline: "Asset View",
      totalPortfolio: "Total Portfolio",
      play: "Play",
      pause: "Pause",
      speed: "Speed",
      amountToSell: "Amount to Sell",
      iconLabel: "Icon",
      iconNone: "No Icon",
      noEvents: "No Life Events",
      noEventsSubtitle: 'Click "Add Event" to add one.',
      type: "Type",
      eventSubtype: "Event Type",
      subtypeReduceIncome: "Reduce Income",
      subtypeDebtRepayment: "Debt Repayment",
      subtypeIncreaseIncome: "Increase Income",
      subtypeYield: "Return",
      subtypeReduceExpenses: "Reduce Expenses",
      subtypeOther: "Other",
      eventOwner: "Who does this apply to?",
      ownerPrimary: "Primary partner",
      ownerPartner: "Partner",
      ownerHousehold: "Whole household",
      escalation: "Annual Change",
      escalationHelp: "Does the amount increase or decrease each year?",
      escalationNone: "No Change",
      escalationPercentage: "Percentage",
      escalationFixed: "Fixed Amount",
      escalationRate: "Annual Change Rate (%)",
      escalationRateHelp:
        "Positive = increase, negative = decrease. E.g.: 3 = 3% increase per year",
      escalationAmount: "Annual Change Amount",
      escalationAmountHelp:
        "Positive = increase, negative = decrease. E.g.: 500 = $500 increase per year",
      // eslint-disable-next-line no-template-curly-in-string
      escalationPreview: "In year {year}: ${amount}",
      customYield: "Custom Yield for Purchase",
      customYieldHelp:
        "Set custom return and risk profile for the purchased asset",
      useCustomYield: "Use Custom Yield",
      useCategoryDefault: "Use Category Default",
      expectedReturn: "Expected Return (%)",
      standardDeviation: "Standard Deviation (%)",
      riskProfile: "Risk Profile",
      customProfileHint:
        'To create a custom profile — go to the "Return Assumptions" tab',
      loanAmount: "Loan Amount",
      loanInterestRate: "Average Annual Interest (%)",
      loanPeriodMonths: "Period (months)",
      loanStartYear: "Start Year",
      loanEndYear: "End Year",
      loanTotalRepayment: "Total Repayment",
      loanMonthlyPayment: "Monthly Payment",
      loanPeriodHelp:
        "You can change the number of months — the end year will update accordingly",
      // Pension sell tax
      pensionTaxWarningTitle: "Early Pension Withdrawal — 35% Tax",
      pensionTaxWarningBody:
        "Early withdrawal from pension funds (before eligibility age) is subject to 35% tax on the withdrawn amount. The net amount (after tax) will be added as liquid cash to your portfolio.",
      pensionGrossAmount: "Gross Amount",
      pensionTax35: "Early Withdrawal Tax (35%)",
      pensionNetProceeds: "Net After Tax",
    },
    assumptions: {
      title: "Return and Risk Assumptions",
      subtitle: "Adjust return assumptions for each asset category",
      category: "Category",
      return: "Expected Return (%)",
      stddev: "Standard Deviation (%)",
      riskProfile: "Risk Profile",
      manageProfiles: "Manage Risk Profiles",
      cash: "Cash",
      deposit: "Deposits & Savings",
      stocks: "Stocks",
      crypto: "Crypto",
      rsu: "RSU / Options",
      pension: "Pension",
      realestate: "Real Estate",
      other: "Other",
      debt: "Loans",
    },
    riskProfiles: {
      title: "Manage Risk Profiles",
      subtitle:
        "Risk profiles determine the volatility range of returns in the simulation",
      create: "Create New Profile",
      edit: "Edit",
      duplicate: "Duplicate",
      delete: "Delete",
      save: "Save",
      cancel: "Cancel",
      name: "Profile Name",
      downsideDelta: "Max Downside from Mean (%)",
      upsideDelta: "Max Upside from Mean (%)",
      builtIn: "Built-in",
      custom: "Custom",
      readOnly: "Built-in Profile (read-only)",
      inUse: "In Use",
      cannotDelete: "Cannot delete a profile that is in use",
      confirmDelete: "Delete this profile?",
      nameRequired: "Profile name is required",
      deltaMustBePositive: "Value must be positive",
      tooltipBadYear: "Typical bad year (p5)",
      tooltipGoodYear: "Typical good year (p95)",
      tooltipTruncated:
        "The simulation uses a truncated normal distribution within these bounds",
      migrationBanner:
        "The risk model has been upgraded to profiles — please review your assumptions.",
      migrationDismiss: "Got it",
    },
    breakdown: {
      title: "Asset Breakdown",
      subtitle: "How your portfolio is calculated",
      product: "Product",
      category: "Category",
      value: "Value",
      ownership: "Ownership",
      liquid: "Liquidity",
      included: "Included",
      totalAssets: "Assets",
      totalDebts: "Debts",
      netWorth: "Net Worth",
      liquidAssets: "Liquid Assets",
      nonLiquidAssets: "Illiquid Assets",
      spendableBeforeRetirement: "Available Before Retirement",
      pensionLockedTitle: "Pension Locked Until Retirement Age",
      pensionLockedSubtitle: "Will be added to portfolio at age {age}",
      currentPension: "Current Value",
      expectedPension: "Expected at Retirement",
      monthlyContribution: "Monthly Contribution",
      customYield: "Custom Yield",
      customYieldHelp: "Set custom return and risk for this product",
      useCustomYield: "Use Custom Yield",
      useCategoryDefault: "Use Category Default",
      expectedReturn: "Expected Return",
      standardDeviation: "Standard Deviation",
      riskProfile: "Risk Profile",
      hasCustomYield: "Custom Yield",
      editCustomYield: "Edit Yield",
      clearCustomYield: "Clear Custom Yield",
    },
    pensionTab: {
      title: "Pension Products Detail",
      subtitle: "Manage pension products and tax implications",
      totalMonthlyPension: "Expected Monthly Pension",
      totalLumpSum: "Lump Sum (Hon)",
      totalCurrentValue: "Total Current Value",
      totalProjected: "Total Projected at Retirement",
      atRetirement: "At Retirement",
      perMonth: "/month",
      productClassLabel: "Product Type",
      withdrawalTypeLabel: "Withdrawal Type",
      mekademLabel: "Mekadem",
      eligibilityAgeLabel: "Eligibility Age",
      currentValueLabel: "Current Value",
      projectedValueLabel: "Projected at Retirement",
      monthlyPensionLabel: "Monthly Pension",
      lumpSumLabel: "Lump Sum",
      lumpSumTaxLabel: "Tax on Lump Sum",
      monthlyContributionLabel: "Monthly Contribution",
      maslekaProjectionLabel: "Masleka Projection",
      earlyWithdrawal: "Early Withdrawal",
      earlyWithdrawalToggle: "Withdraw this product (at chosen age)",
      withdrawAtAgeLabel:
        "Withdraw at age (from now until pension eligibility)",
      accumulatedAtAgeLabel: "Accumulated value at age {age}",
      earlyWithdrawalWarning:
        "Early withdrawal is taxed at 35% on the full amount",
      earlyWithdrawalTax: "Early Withdrawal Tax (35%)",
      earlyWithdrawalNet: "Net After Tax",
      earlyWithdrawalImpact:
        "Amount will be added as liquid assets and removed from pension projection",
      earlyKitzbaToggle: "Start early annuity (at chosen age)",
      startKitzbaAtAgeLabel: "Annuity start age (from 60 to eligibility)",
      earlyKitzbaExplanation:
        "Early withdrawal as an annuity: each year before the official pension age raises the coefficient by 12, so the monthly annuity is lower — but starts earlier and with no 35% tax. {years} years early.",
      earlyKitzbaMekademLabel: "Adjusted coefficient",
      earlyKitzbaMonthlyGrossLabel: "Monthly annuity (gross)",
      earlyKitzbaMonthlyNetLabel: "Monthly annuity (net)",
      kitzba: "Annuity",
      hon: "Lump Sum",
      mixed: "Mixed",
      noProducts: "No pension products found",
      ownerLabel: "Owner",
      filterByOwner: "Filter by owner",
      filterAll: "All",
      taxImplications: "Tax Implications",
      kitzbaTaxExemption: "Qualifying Pension Exemption",
      kitzbaTaxNote:
        "Up to {amount} ₪/month is tax-exempt ({percent}% exemption)",
      lumpSumTaxNote: "15% capital gains tax on the gain portion of lump sum",
      earlyTaxNote:
        "35% tax on the full amount for withdrawal before eligibility age",
      summaryTitle: "Pension Summary at Retirement",
      netMonthlyAfterTax: "Net Monthly Pension (After Tax)",
      excludedProducts: "Liquid Products (Excluded from Pension)",
      // Pension Simulator
      simulatorTitle: "Pension Simulator",
      simulatorSubtitle:
        "Explore different pension scenarios — retirement age, monthly pension, and early withdrawal",
      pensionStartAge: "Pension Start Age",
      pensionValueOverTime: "Pension Value Over Time",
      monthlyPensionByAge: "Monthly Pension by Start Age",
      scenarioComparison: "Scenario Comparison",
      scenarioAge: "Age",
      scenarioMonthly: "Monthly Pension",
      scenarioMonthlyNet: "Monthly Net",
      scenarioTotalValue: "Projected Value",
      scenarioCumulativeIncome: "Cumulative Income by Age {life}",
      chartPensionValue: "Pension Value",
      chartMonthlyPension: "Monthly Pension (Gross)",
      chartMonthlyPensionNet: "Monthly Pension (Net)",
      chartEarlyWithdrawal: "Early Withdrawal (Net after 35% Tax)",
      earlyPensionNote:
        "Under Israeli law, some products (provident funds, investment funds) allow pension from age 60.",
      selectedAge: "Selected Age: {age}",
      atAge: "At Age {age}",
      tabValueOverTime: "Value Over Time",
      tabMonthlyByAge: "Pension by Age",
      tabDeposits: "Deposits",
      tabContributionTable: "Contributions & Growth by Year",
      tableYear: "Year",
      tableAge: "Age",
      tableContributionYear: "Contribution (Year)",
      tableGrowth: "Growth",
      tableValueEndOfYear: "Value (End of Year)",
      apply: "Apply",
    },
    warnings: {
      title: "Warnings",
    },
    buttons: {
      recalculate: "Recalculate",
      resetDefaults: "Reset to Default Assumptions",
      resetAllSettings: "Reset All",
      resetAllSettingsConfirm: "Reset all settings?",
      reloadFromData: "Reload from Data",
      moreActions: "More Actions",
      actions: "Actions",
      lastSaved: "Last Saved",
      newDataAvailable: "New Data Available",
      exportExcel: "Export to Excel",
      exportExcelTooltip: "Download financial projection as an Excel file",
      exporting: "Exporting...",
      exportError: "Export Error",
      retirementGraphGuide: "Retirement Graph Guide",
    },
    excel: {
      title: "Financial Projection",
      subtitle: "Financial Projection",
      sheetName: "Retirement Projection",
      userInfo: "User Info",
      currentAge: "Current Age",
      retirementAge: "Retirement Age",
      lifeExpectancy: "Life Expectancy",
      withdrawalRate: "Withdrawal Rate",
      monthlySpend: "Monthly Expenses",
      monthlyIncome: "Monthly Income",
      monthlySavings: "Monthly Savings",
      ageRow: "Age",
      yearRow: "Year",
      incomeSection: "Income",
      incomeImplied: "Monthly Income (salary)",
      totalIncome: "Total Income",
      expenseSection: "Expenses",
      monthlyExpenses: "Monthly Expenses",
      totalExpenses: "Total Expenses",
      incomeMinusExpenses: "Income Minus Expenses",
      fireNumber: "FIRE Number",
      fireNumberBy4: "At 4%",
      fireNumberBy3: "At 3.3%",
      surplusDeficit: "Cumulative Surplus / Deficit",
      assetsSection: "Assets",
      assetCurrentValue: "Current Value",
      assetReturn: "Return",
      totalAssets: "Assets",
      liquidAssets: "Of Which Liquid",
      lockedPension: "Locked Pension",
      liabilitiesSection: "Liabilities and One-time Expenses",
      totalLiabilities: "Total Liabilities",
      netAssets: "Total Assets Minus Liabilities",
      poweredBy: "Powered by Moneytor",
      generatedAt: "Generated at ",
    },
    monteCarloSettings: {
      simulations: "Number of Simulations",
      simulationsHelp: "More simulations = more accurate results (but slower)",
    },
    goals: {
      tabTitle: "Goals",
      title: "Retirement Goals",
      subtitle:
        "Define financial goals and check the probability of achieving them",
      add: "Add Goal",
      edit: "Edit",
      save: "Save",
      cancel: "Cancel",
      delete: "Delete",
      enabled: "Enabled",
      disabled: "Disabled",
      goalName: "Goal Name",
      targetAmount: "Target Amount",
      targetAmountHelp: "The amount you want to reach",
      targetAge: "Target Age",
      targetAgeHelp: "The age by which you want to achieve this goal",
      // Goal kind labels
      kindPortfolioTarget: "Portfolio Target",
      kindPortfolioTargetDesc: "Accumulate a specific amount by a specific age",
      kindPortfolioSurvives: "Portfolio Survival",
      kindPortfolioSurvivesDesc:
        "Money doesn't run out through life expectancy",
      kindFireByAge: "FIRE by Age",
      kindFireByAgeDesc: "Reach financial independence by a specific age",
      kindMinimumFloor: "Safety Floor",
      kindMinimumFloorDesc: "Portfolio never drops below a certain amount",
      kindPurchaseGoal: "Future Purchase",
      kindPurchaseGoalDesc:
        "Buy an asset at a specific age — amount is withdrawn and survival is checked after",
      // Default goal names
      defaultSurvive: "Survive through life expectancy",
      defaultBuyHome: "Buy a home",
      defaultFireByAge: "Financial independence",
      defaultMinFloor: "Safety floor",
      defaultPurchase: "Buy a home",
      // Results
      overallSuccess: "Chance of meeting all goals",
      goalSuccess: "Success probability",
      deterministicMet: "Met in projection",
      deterministicNotMet: "Not met in projection",
      metAtAge: "Met at age",
      noGoals: "No goals defined",
      noGoalsSubtitle: "Add a goal to see the probability of achieving it",
      // Presets
      presets: "Goal presets",
      addFromPreset: "Add from template",
    },
    aiChat: {
      title: "Plan with AI",
      subtitle:
        "Describe your plans and AI will create a personalized scenario",
      placeholder:
        "Tell me about your plans... e.g.: I want to buy an apartment in 5 years, send kids to college...",
      send: "Send",
      apply: "Apply Scenario",
      applyAndClose: "Apply & Close",
      preview: "Preview",
      generating: "Generating scenario...",
      error: "Error generating scenario",
      errorRetry: "Try again",
      close: "Close",
      eventsPreview: "Life Events",
      goalsPreview: "Goals",
      scenarioName: "Scenario Name",
      noEventsGenerated: "No events generated",
      noGoalsGenerated: "No goals generated",
      appliedSuccess: "Scenario applied successfully!",
      suggestedRetirementAge: "Suggested retirement age",
      acceptSuggestion: "Accept",
      openButton: "Plan with AI",
      openButtonTooltip:
        "Describe your plans and AI will create a personalized scenario",
      newChat: "New Chat",
      eventCount: "events",
      goalCount: "goals",
      voiceListening: "Listening...",
      voiceTapToSpeak: "Tap to speak",
      voiceTapToStop: "Tap to stop and send",
      voiceNotSupported: "Voice input is not supported in this browser",
      direction: {
        inflow: "Income",
        outflow: "Expense",
      },
      frequency: {
        oneTime: "One-time",
        monthly: "Monthly",
        yearly: "Yearly",
      },
    },
    ui: {
      eventTypes: {
        buy: "Purchase",
        sell: "Sale",
        loan: "Loan",
      },
      lifeEventIcons: {
        home: "Home",
        car: "Vehicle",
        school: "Education",
        baby: "Baby",
        family: "Family",
        flight: "Flight / Vacation",
        work: "Work",
        medical: "Medical",
        celebration: "Celebration / Wedding",
        gift: "Gift",
        restaurant: "Dining / Food",
        fitness: "Sports / Health",
        pets: "Pets",
        renovation: "Renovation",
        laptop: "Technology",
        trendingUp: "Increase / Growth",
        trendingDown: "Decrease / Decline",
        savings: "Savings",
        beach: "Retirement / Leisure",
        donate: "Donation",
        bank: "Bank / Loan",
        shopping: "Shopping",
      },
    },
    help: {
      fire: {
        title: "🔥 What is FIRE?",
        p1Text:
          "(Financial Independence, Retire Early) is a financial movement aimed at achieving financial independence — the state where you have enough assets to cover your living expenses for life, without working. This doesn't necessarily mean quitting your job — rather, working becomes",
        p1Choice: "a choice",
        p1Separator: ", not ",
        p1Necessity: "a necessity",
        p2Text:
          "The idea is simple: accumulate enough wealth so that its annual return covers your expenses. This amount is called the",
        p2FireNumber: "FIRE number",
      },
      goals: {
        title: "🎯 Retirement Goals",
        introTitle: "What Are Retirement Goals?",
        introDesc:
          "Instead of relying on a single FIRE number, the calculator lets you define personal goals that reflect your financial objectives. Each goal gets its own success probability.",
        typesTitle: "Goal Types",
        typePortfolioSurvivesTitle: "🏖️ Portfolio Survives",
        typePortfolioSurvivesDesc:
          "The most fundamental goal — your money doesn't run out before life expectancy. The calculator checks how many simulation scenarios end with a positive portfolio.",
        typePortfolioTargetTitle: "🏠 Portfolio Target at Age",
        typePortfolioTargetDesc:
          "Want to reach ₪X by age Y? For example: ₪2,000,000 by age 55 for a home purchase. The calculator checks in what percentage of scenarios the portfolio reached that amount.",
        typePurchaseTitle: "🛒 Future Purchase",
        typePurchaseDesc:
          "Plan a large expense at a specific age (home, car, wedding). This goal checks if the portfolio can fund the purchase, and automatically creates a life event expense that deducts the amount from the portfolio.",
        typeFireByAgeTitle: "📈 FIRE by Age",
        typeFireByAgeDesc:
          "Reach financial independence (FIRE number) by a specific age. The calculator checks in what percentage of scenarios you hit the target.",
        typeMinFloorTitle: "💰 Minimum Floor",
        typeMinFloorDesc:
          "Maintain a minimum portfolio balance throughout retirement, e.g. ₪500,000 as a safety net. The calculator checks that the portfolio never drops below this amount.",
        howItWorksTitle: "How Does It Work?",
        howItWorksDesc:
          "Each goal gets a separate success probability — the chance it's achieved across all Monte Carlo simulations. Additionally, an overall success probability is shown — the chance of achieving all goals together.",
        tipsTitle: "Tips",
        tip1: "Start with a basic portfolio survival goal — it's the most important one",
        tip2: "Add purchase goals to plan for large expenses (they automatically create life events)",
        tip3: "Toggle goals on/off to see how they affect the overall probability",
        tip4: "Aim for above 80% success probability for each goal",
      },
      keyNumbers: {
        title: "📊 The Numbers Above the Graph",
        fireNumberTitle: "FIRE Number — How Much Do You Need?",
        fireNumberDesc:
          "The total amount you need to accumulate to retire. Calculated as: annual expenses ÷ withdrawal rate.",
        fireNumberExample:
          "For example: if monthly expenses are ₪15,000 (₪180,000/year) and the withdrawal rate is 4%, the FIRE number is",
        fireNumberExampleValue: "₪4,500,000",
        yearsTitle: "Years to FIRE — When Can You Retire?",
        yearsDesc:
          "The number of years it will take to reach your FIRE number, based on your current portfolio, monthly savings, and expected returns. If the number seems too high, try increasing savings, reducing expenses, or considering a higher withdrawal rate.",
        successTitle: "Success Probability — How Safe Is It?",
        successDesc:
          "Appears when the Monte Carlo simulation is enabled. Represents the percentage of scenarios in which your money doesn't run out before the end of your life expectancy.",
        successThresholds:
          "Above 80% is considered good, above 90% is considered excellent.",
      },
      withdrawalRate: {
        title: "💰 Withdrawal Rate — The Most Important FIRE Concept",
        p1Label: "The withdrawal rate",
        p1Text:
          "is the percentage you withdraw from your portfolio each year to cover expenses. It determines how much money you need to accumulate (FIRE number = annual expenses ÷ withdrawal rate).",
        p2Label: "The 4% Rule:",
        p2Text:
          "The well-known Trinity Study found that withdrawing 4% per year from a stock and bond portfolio survived nearly all historical periods (30+ years) in the U.S. market.",
        examplesTitle:
          "Examples — monthly expenses of ₪15,000 (₪180,000/year):",
        colWithdrawalRate: "Withdrawal Rate",
        colFireNumber: "FIRE Number",
        colConfidence: "Confidence Level",
        colSuitableFor: "Suitable For...",
        row3Confidence: "Very High",
        row3Suitable: "Early retirement (30+ years), conservative investors",
        row4Confidence: "High",
        row4Suitable: "Recommended default, standard retirement",
        row5Confidence: "Moderate",
        row5Suitable: "Late retirement, additional income (pension, rental)",
        row6Confidence: "Lower",
        row6Suitable: "Significant additional fixed income available",
        footerText:
          "The lower the withdrawal rate, the more you need to save — but the chance that your money lasts significantly increases.",
      },
      calculator: {
        title: "🧮 What Does This Calculator Do?",
        autoCalcLabel: "Automatic Calculation",
        autoCalcDesc:
          "Loads all your assets, expenses, and income directly from your data in the system",
        visualLabel: "Visual Projection",
        visualDesc:
          "A graph showing your portfolio growth over the years, through and beyond retirement",
        monteCarloLabel: "Monte Carlo Simulation",
        monteCarloDesc:
          "Hundreds of random scenarios showing the range of possible outcomes and success probability",
        lifeEventsLabel: "Life Events",
        lifeEventsDesc:
          "Plan future events (home purchase, inheritance, children's education) and see how they impact the projection",
        scenariosLabel: "Scenarios",
        scenariosDesc:
          "Compare different scenarios (optimistic, pessimistic) to make informed decisions",
        goalsLabel: "Personal Goals",
        goalsDesc:
          "Define retirement goals (portfolio survival, future purchases, FIRE) and see the probability of achieving each one",
        customLabel: "Full Customization",
        customDesc:
          "Adjust return assumptions, risk profiles, and include/exclude assets as needed",
      },
      graphElements: {
        title: "📊 What's Shown on the Graph",
        projectionTitle: "Projection Line (Blue)",
        projectionDesc:
          "A deterministic projection of your portfolio value over the years. Based on the return assumptions you set for each asset category.",
        monteCarloBandsTitle: "Monte Carlo Bands",
        p90Label: "P90 (Green)",
        p90Desc:
          "Optimistic scenario (only 10% of simulations yielded a better outcome)",
        p50Label: "P50 (Orange)",
        p50Desc: "Median (50% of simulations were above/below this line)",
        p10Label: "P10 (Red)",
        p10Desc:
          "Pessimistic scenario (90% of simulations yielded a better outcome)",
        fireLineTitle: "FIRE Line (Green Dashed)",
        fireLineDesc:
          "The amount you need to retire. Calculated as: annual expenses ÷ safe withdrawal rate.",
        fireLineExample:
          "For example: if monthly expenses are ₪20,000 and the withdrawal rate is 4%, the FIRE number is ₪6,000,000.",
        retirementLineTitle: "Retirement Line (Blue Dashed)",
        retirementLineDesc:
          "The age at which you plan to stop working. From this point, instead of adding savings, you begin withdrawing from the portfolio.",
      },
      calculation: {
        title: "🧮 How the Projection Is Calculated",
        accumulationTitle: "Accumulation Phase (Pre-Retirement)",
        accumulationItem1:
          'Monthly savings accumulate as "buying credit" (not automatically invested)',
        accumulationItem2:
          "Existing assets grow according to the return set for each category",
        accumulationItem3:
          "Life events (purchases, sales, income) affect the portfolio",
        withdrawalTitle: "Withdrawal Phase (Post-Retirement)",
        withdrawalItem1:
          "Each year, monthly expenses × 12 are withdrawn, adjusted for inflation",
        withdrawalItem2Label: "Important:",
        withdrawalItem2Text:
          "Withdrawals are based on actual expenses, not the withdrawal rate",
        withdrawalItem3: "Assets continue to grow, net of withdrawals",
        inflationTitle: "Inflation Adjustment",
        inflationDesc:
          "All amounts (expenses, withdrawals) are adjusted for the specified inflation rate. If expenses today are ₪15,000 and inflation is 2%, in 10 years they will be ₪18,285.",
      },
      pension: {
        title: "🏦 Pension",
        whenTitle: "When Does the Pension Kick In?",
        whenDesc: "The pension is locked until the legal eligibility age:",
        whenForMales: "for males,",
        whenForFemales: "for females",
        whenEarlyRetirement:
          "Even if you retire earlier, the pension will only be added at the eligibility age.",
        includedTitle: "What's Included in the Pension Calculation?",
        includedItem1: "Current value of pension funds",
        includedItem2:
          "Future contributions (employee + employer) until eligibility age",
        includedItem3: "Expected return (~4.3% annually)",
        includedItem4:
          "Management fees (from contributions and accumulated balance)",
        excludedLabel: "Not included:",
        excludedText:
          "Education funds (Keren Hishtalmut) — liquid before pension age",
        graphTitle: "On the Graph",
        graphDesc:
          "At pension eligibility age, annuity products start providing a steady monthly income that reduces portfolio withdrawals. Lump-sum products are added to the portfolio as a one-time amount.",
      },
      pensionLaw: {
        title: "📋 Israeli Pension Law",
        productTypesTitle: "Pension Product Types",
        productTypesDesc:
          "Each pension product behaves differently at retirement:",
        kerenPensiaTitle: "Keren Pensia (Annuity Pension Fund)",
        kerenPensiaDesc:
          "The most common product. Accumulated savings are converted to a monthly annuity at retirement using an annuity coefficient (mekadem). Includes disability and survivors insurance.",
        bituachMenahalimTitle: "Bituach Menahalim (Manager Insurance)",
        bituachMenahalimDesc:
          "A life insurance policy with a savings component. Can be redeemed as an annuity, a lump sum, or a combination. Includes disability and survivors insurance.",
        kupatGemelKitzbatitTitle: "Kupat Gemel (Annuity, post-2008)",
        kupatGemelKitzbatitDesc:
          "Deposits from 2008 onward are designated for annuity only and cannot be redeemed as a lump sum.",
        kupatGemelHonitTitle: "Kupat Gemel (Lump Sum, pre-2008)",
        kupatGemelHonitDesc:
          "Deposits made before 2008 can be redeemed as a tax-free lump sum from age 60.",
        kupatGemelLehashkaaTitle:
          "Kupat Gemel LeHashkaa (Investment Provident Fund)",
        kupatGemelLehashkaaDesc:
          "Redeemable from age 60 as a lump sum (15% capital gains tax) or as a tax-free annuity. Annual deposit cap ~82,000 ILS.",
        kerenHishtalmutTitle: "Keren Hishtalmut (Education Fund)",
        kerenHishtalmutDesc:
          "Liquid after 6 years of vesting, fully tax-exempt. Not a pension product — displayed under 'Other' and not locked until retirement.",

        mekademTitle: "Annuity Coefficient (Mekadem)",
        mekademDesc:
          "The mekadem determines how much monthly pension you receive from your accumulated savings:",
        mekademFormula: "Monthly Pension = Total Accumulation ÷ Mekadem",
        mekademExample:
          "Example: 1,000,000 ILS ÷ 220 mekadem = 4,545 ILS/month",
        mekademFactorsTitle: "What Affects the Mekadem?",
        mekademFactor1:
          "Retirement age — lower mekadem (higher pension) the later you retire",
        mekademFactor2:
          "Gender — higher mekadem (lower pension) for women due to longer life expectancy",
        mekademFactor3:
          "Marital status — higher mekadem for married people due to survivors pension",
        mekademSourceTitle: "Mekadem Source",
        mekademSourceDesc:
          "If a guaranteed mekadem exists in the Masleka data, the calculator uses it. Otherwise, a default actuarial table is used.",

        taxTitle: "Pension Taxation",
        taxKitzbaTitle: "Monthly Annuity at Retirement",
        taxKitzbaDesc:
          "Qualifying pension (up to 9,430 ILS/month) is tax-exempt at an increasing rate: 57% in 2025, 60% in 2026, up to 67% in 2028. The amount above the exemption is taxed at the marginal rate.",
        taxLumpSumTitle: "Lump Sum Withdrawal",
        taxLumpSumDesc:
          "Amendment 190: 15% real capital gains tax on the gain component only (compared to 25% in the capital markets).",
        taxEarlyTitle: "Early Withdrawal (Before Retirement Age)",
        taxEarlyDesc:
          "Flat 35% tax on the entire withdrawal amount. Non-refundable (except for disability or severe illness exceptions).",

        contributionsTitle: "Income Impact on Contributions",
        contributionsDesc:
          "Pension contributions are salary-based (6% employee + 6.5% employer + 6-8.33% severance). When income drops (switching to part-time, early retirement), contributions decrease proportionally, reducing the expected accumulation at retirement.",
        contributionsRetirement: "At retirement, contributions stop entirely.",

        pitzuimTitle: "Severance Pay (Pitzuim)",
        pitzuimDesc:
          "About 40% of pension accumulation comes from employer severance contributions. Early withdrawal of severance significantly reduces the future pension annuity.",

        retirementAgeTitle: "Retirement Age",
        retirementAgeDesc:
          "Pension eligibility: 67 for men, 65 for women. Early retirement is possible but without pension income until the eligibility age — the gap period must be funded from the liquid portfolio.",
      },
      monteCarlo: {
        title: "🎲 Monte Carlo Simulation",
        whatTitle: "What Is It?",
        whatDesc:
          "Instead of assuming a fixed return, the simulation runs hundreds of random scenarios. Each asset category has a risk profile that defines the range of fluctuations — the simulation randomly generates an annual return within that range each year.",
        successTitle: "Success Probability",
        successDesc:
          "The percentage of simulations in which the portfolio doesn't run out before the end of life expectancy.",
        successAbove90: "Above 90% — Excellent",
        success75to90: "75–90% — Good",
        successBelow75:
          "Below 75% — Consider increasing savings or reducing expenses",
        whyTitle: "Why Does It Matter?",
        whyDesc:
          "Markets don't rise at a steady pace. There can be great years (+20%) and terrible years (−30%). Monte Carlo helps you understand the range of possible outcomes.",
      },
      riskProfilesHelp: {
        title: "🎯 Risk Profiles",
        whatTitle: "What Is a Risk Profile?",
        whatDesc:
          "A risk profile defines the volatility range of returns in the simulation. Instead of entering a standard deviation manually, you choose a profile that describes the intensity of fluctuations — how much the asset might drop in a bad year and how much it might rise in a good year.",
        howTitle: "How Does It Work?",
        howDesc: "Each profile is defined by two numbers:",
        howP5Label: "Typical maximum drop (p5)",
        howP5Desc:
          "In a bad year (1 in 20), the return drops roughly by this amount below the average",
        howP95Label: "Typical maximum rise (p95)",
        howP95Desc:
          "In a good year (1 in 20), the return rises roughly by this amount above the average",
        howDistribution:
          "The simulation uses a truncated normal distribution within these bounds to generate realistic random returns.",
        examplesTitle: "Practical Examples",
        exBankTitle: '🏦 Bank Deposit — "Conservative" Profile (↓3% / ↑5%)',
        exBankStats: "Expected return: 3% | Bad year: 0% | Good year: 8%",
        exBankDesc:
          "A ₪500,000 portfolio — most years you'll earn ₪10,000–₪40,000. Virtually no risk of loss.",
        exStocksTitle: '📈 S&P 500 Index — "Growth" Profile (↓20% / ↑30%)',
        exStocksStats: "Expected return: 7% | Bad year: −13% | Good year: 37%",
        exStocksDesc:
          "A ₪500,000 portfolio — in a good year you could gain ₪185,000, but in a bad year you could lose ₪65,000.",
        exCryptoTitle: '₿ Crypto — "Speculative" Profile (↓40% / ↑75%)',
        exCryptoStats: "Expected return: 10% | Bad year: −30% | Good year: 85%",
        exCryptoDesc:
          "A ₪500,000 portfolio — could drop to ₪350,000 in a bad year, but also jump to ₪925,000 in a good year.",
        defaultsTitle: "Default Profiles by Category",
        defaultsDesc:
          "Each asset category is automatically assigned an appropriate risk profile:",
        defaultCash: "Cash",
        defaultCashProfile: "Capital preservation (minimal volatility)",
        defaultDeposits: "Deposits",
        defaultDepositsProfile: "Conservative",
        defaultPension: "Pension",
        defaultPensionProfile: "Balanced",
        defaultRealestate: "Real Estate",
        defaultRealestateProfile: "Moderate growth",
        defaultStocks: "Stocks",
        defaultStocksProfile: "Growth",
        defaultRsu: "RSU / Options",
        defaultRsuProfile: "Aggressive",
        defaultCrypto: "Crypto",
        defaultCryptoProfile: "Speculative",
        customTitle: "Custom Profiles",
        customDesc:
          'You can create custom risk profiles via the "Manage Risk Profiles" button in the',
        customDescTab: "Return Assumptions",
        customExample:
          "For example: if you invest in a conservative equity fund that behaves differently from the S&P, you can create a profile with ↓12% / ↑18% that better describes the fund's behavior.",
      },
      lifeEvents: {
        title: "📅 Life Events",
        typesTitle: "Event Types",
        typeIncomeExpenseLabel: "Income/Expense",
        typeIncomeExpenseDesc:
          "Money coming in or going out (inheritance, wedding, education)",
        typeBuyLabel: "Buy Asset",
        typeBuyDesc: "Investment in a specific category",
        typeSellLabel: "Sell Asset",
        typeSellDesc: "Liquidating assets (transfers to buying credit)",
        creditTitle: "Buying Credit",
        creditDesc:
          "Money that has accumulated and is waiting to be invested. Composed of:",
        creditItem1: "Monthly savings that haven't been invested",
        creditItem2: "Proceeds from asset sales",
        creditItem3: "One-time income",
        creditNote: "Note:",
        creditNoteText:
          "Buying credit doesn't grow (0% return) until it's used to purchase an asset.",
      },
      tips: {
        title: "💡 Tips",
        tip1: "Keep your monthly expenses realistic — this is the most critical input",
        tip2: "Add expected life events (children's education, home purchase, inheritance)",
        tip3: "Use Monte Carlo to see the range of possible outcomes",
        tip4: "Check the success probability — aim for above 80%",
        tip5Warning:
          "The projection is based on assumptions — reality may differ",
      },
    },
  },
  RUS: {
    title: "Пенсионный калькулятор",
    tabs: {
      inputs: "Базовые данные",
      events: "Жизненные события",
      assumptions: "Предположения о доходности",
      breakdown: "Состав активов",
      pension: "Пенсия",
    },
    advancedSection: {
      title: "Расширенные настройки",
      subtitle:
        "Нормы снятия, инфляция, предположения о доходности и состав активов",
      tabSettings: "Настройки",
      tabReturns: "Доходность и риск",
      tabBreakdown: "Состав активов",
    },
    inputs: {
      gender: "Пол",
      genderHelp:
        "Влияет на законный пенсионный возраст (67 для мужчин, 65 для женщин)",
      genderMale: "Мужской",
      genderFemale: "Женский",
      currentAge: "Текущий возраст",
      currentAgeHelp: "Ваш возраст сегодня",
      retirementAge: "Планируемый пенсионный возраст",
      retirementAgeHelp: "Возраст, в котором вы планируете прекратить работу",
      lifeExpectancy: "Ожидаемая продолжительность жизни",
      lifeExpectancyHelp:
        "Ожидаемая продолжительность жизни для расчёта бюджета",
      monthlySpend: "Ежемесячные расходы",
      monthlySpendHelp: "Ежемесячные расходы, которые вы ожидаете на пенсии",
      monthlyIncome: "Ежемесячный доход",
      monthlyIncomeHelp:
        "Общий чистый ежемесячный доход (включая зарплату, дополнительный доход)",
      monthlySavings: "Ежемесячные сбережения",
      monthlySavingsHelp: "Рассчитывается автоматически: доход минус расходы",
      syncFromCashflow: "Рассчитать автоматически за последние 6 месяцев",
      coupleToggle: "Планирование как пара",
      coupleToggleHelp: "Разделите доход между двумя партнёрами, у каждого свой возраст, пол и пенсионный возраст",
      partner1: "Партнёр 1",
      partner2: "Партнёр 2",
      partnerIncome: "Ежемесячный доход",
      householdIncome: "Доход семьи (всего)",
      partnerGender: "Пол",
      partnerCurrentAge: "Текущий возраст",
      partnerRetirementAge: "Пенсионный возраст",
      withdrawalRate: "Норма снятия (%)",
      withdrawalRateHelp:
        "Годовая норма снятия из портфеля (4% считается безопасной)",
      inflation: "Инфляция (%)",
      inflationHelp: "Ожидаемый годовой уровень инфляции",
      startingPortfolio: "Начальный портфель",
      startingPortfolioHelp: "Текущая стоимость вашего портфеля",
    },
    toggles: {
      includeRealestate: "Включить неликвидную недвижимость",
      includeRealestateHelp:
        "Включать ли неликвидную недвижимость в инвестиционный портфель",
      includePension: "Включить пенсию до пенсионного возраста",
      includePensionHelp:
        "Включать ли пенсионные фонды до пенсионного возраста",
      includeUnvestedRSU: "Включить невестированные RSU",
      includeUnvestedRSUHelp:
        "Включать ли невестированные RSU как жизненные события",
      monteCarlo: "Включить Monte Carlo",
      monteCarloHelp:
        "Запустить стохастическую симуляцию для расчёта вероятности успеха",
      advancedSettings: "Расширенные настройки",
    },
    results: {
      fireNumber: "Число FIRE",
      fireNumberHelp: "Сумма, необходимая для досрочного выхода на пенсию",
      yearsToFire: "Лет до FIRE",
      yearsToFireHelp: "Количество лет до достижения числа FIRE",
      successProbability: "Вероятность успеха",
      successProbabilityHelp:
        "Шанс, что портфель продержится до конца ожидаемой продолжительности жизни",
      weightedReturn: "Взвешенная доходность",
      weightedReturnHelp:
        "Средневзвешенная годовая доходность по составу портфеля",
    },
    chartView: {
      projectionChart: "График прогноза",
      assetMap: "Карта активов",
      fullscreen: "Полный экран",
      exitFullscreen: "Выйти из полного экрана",
      totalPortfolio: "Итого портфель",
      age: "Возраст",
      speed: "Скорость",
      projection: "Прогноз",
      earlyRetirement: "Досрочная пенсия",
      pension: "Пенсия",
      now: "сейчас",
      inOneYear: "через 1 год",
      inYearsPrefix: "через",
      yearsSuffix: "лет",
      eventsCount: "событий",
      moreEvents: "ещё",
      normalView: "Обычный вид",
      durationView: "Вид длительности",
      zoomIn: "Увеличить",
      zoomOut: "Уменьшить",
      zoom: "Масштаб",
      viewMenu: "Вид",
      shrinkEvents: "Свернуть события",
      expandEvents: "Развернуть события",
      showLines: "Показать линии",
      hideLines: "Скрыть линии",
      noAssetsInYear: "Нет активов в году",
      returnsAndIncome: "Доходность + Доход",
      monthlyIncome: "Ежемесячный доход",
      monthlyWithdrawal: "Ежемесячное снятие",
      monthlyExpenses: "Ежемесячные расходы",
      netCashflow: "Чистый денежный поток",
      monthlySavings: "Ежемесячные сбережения",
      resetZoom: "Сброс",
      cashflowChart: "Доходы и расходы (месячные)",
      cashflowChartTab: "Доходы и расходы",
      salaryIncome: "Доход от зарплаты",
      pensionIncome: "Пенсионный доход",
      eventIncome: "Доход от событий",
      investReturns: "Доходы от инвестиций",
      livingExpenses: "Расходы на жизнь",
      eventExpenses: "Расходы на события",
      pensionTax: "Пенсионный налог",
      totalAssets: "Итого активы",
      income: "Доходы",
      expenses: "Расходы",
      surplus: "Профицит",
      deficit: "Дефицит",
      primaryPartner: "Основной партнёр",
      secondPartner: "Партнёр",
    },
    events: {
      title: "Жизненные события",
      subtitle: "Добавьте события, которые повлияют на прогноз",
      addScenario: "Новый сценарий",
      addScenarioWithAI: "Сценарий с AI",
      deleteScenario: "Удалить сценарий",
      deleteScenarioConfirm: "Удалить этот сценарий?",
      renameScenario: "Переименовать",
      scenarioActive: "Активный",
      scenarioName: "Название сценария",
      defaultScenarioName: "Новый сценарий",
      eventsInScenario: "Событий в",
      eventsCount: "событий",
      add: "Добавить событие",
      edit: "Редактировать",
      save: "Сохранить",
      cancel: "Отмена",
      delete: "Удалить",
      addEventType: "Тип события",
      cashflowEvent: "Доход/Расход",
      buyAssetEvent: "Покупка актива",
      sellAssetEvent: "Продажа актива",
      loanEvent: "Кредит",
      name: "Название события",
      amount: "Сумма",
      startYear: "Год",
      endYear: "Год окончания",
      endYearMode: "Заканчивается в",
      endYearSpecific: "Конкретный год",
      endYearRetirement: "Пенсия",
      endYearPension: "Пенсионный возраст",
      endYearLifeExpectancy: "Ожидаемая продолжительность жизни",
      frequency: "Частота",
      direction: "Направление",
      oneTime: "Разовый",
      monthly: "Ежемесячно",
      yearly: "Ежегодно",
      inflow: "Доход",
      outflow: "Расход",
      category: "Категория",
      investFrom: "Источник финансирования",
      investFromCashflow: "Из текущих сбережений",
      investFromCashflowHelp: "Будет вычтено из ежемесячных сбережений",
      investFromExtra: "Дополнительные средства",
      investFromExtraHelp: "Подарок/бонус — не будет вычтено из сбережений",
      investFromBuyingCredit: "Из кредита на покупку",
      investFromBuyingCreditHelp:
        "Использует кредит, накопленный от продаж и сбережений",
      sellType: "Тип продажи",
      sellTypeAmount: "Фиксированная сумма",
      sellTypePercentage: "Процент от актива",
      sellAmount: "Сумма продажи",
      sellPercentage: "Процент продажи",
      selectProduct: "Выберите актив",
      allProductsInCategory: "Все активы в категории (пропорционально)",
      specificProduct: "Конкретный актив",
      boughtAssetTag: "Запланированная покупка",
      currentValue: "Текущая стоимость",
      buyingCredit: "Кредит на покупку",
      buyingCreditHelp:
        "Кредит на покупку = остаток наличных (от сбережений, продаж, дохода)",
      availableCredit: "Доступный кредит",
      insufficientCredit:
        "Недостаточно кредита — попробуйте сначала продать актив",
      insufficientCreditRecurring:
        "Недостаточно кредита на весь период события",
      insufficientCreditForExpense:
        "Недостаточно средств в портфеле для покрытия расхода — попробуйте сначала продать актив",
      insufficientCreditForExpenseRecurring:
        "Недостаточно средств в портфеле для покрытия расхода на весь период",
      missingAmount: "Не хватает",
      portfolioValueInYear: "Стоимость портфеля в году",
      availableInCategory: "Доступно в категории",
      creditInYear: "Кредит в году",
      categoryBalanceInYear: "Ожидаемая стоимость в году",
      selectYear: "Выберите год",
      assetTimeline: "Просмотр активов",
      totalPortfolio: "Итого портфель",
      play: "Воспроизвести",
      pause: "Пауза",
      speed: "Скорость",
      amountToSell: "Сумма для продажи",
      iconLabel: "Иконка",
      iconNone: "Без иконки",
      noEvents: "Нет жизненных событий",
      noEventsSubtitle: 'Нажмите "Добавить событие" для добавления.',
      type: "Тип",
      eventSubtype: "Тип события",
      subtypeReduceIncome: "Уменьшение дохода",
      subtypeDebtRepayment: "Погашение долга",
      subtypeIncreaseIncome: "Увеличение дохода",
      subtypeYield: "Доходность",
      subtypeReduceExpenses: "Сокращение расходов",
      subtypeOther: "Другое",
      eventOwner: "К кому это относится?",
      ownerPrimary: "Основной партнёр",
      ownerPartner: "Партнёр",
      ownerHousehold: "Всё домохозяйство",
      escalation: "Ежегодное изменение",
      escalationHelp: "Сумма увеличивается или уменьшается каждый год?",
      escalationNone: "Без изменений",
      escalationPercentage: "Процент",
      escalationFixed: "Фиксированная сумма",
      escalationRate: "Годовая ставка изменения (%)",
      escalationRateHelp:
        "Положительное = увеличение, отрицательное = уменьшение. Напр.: 3 = рост на 3% в год",
      escalationAmount: "Годовая сумма изменения",
      escalationAmountHelp:
        "Положительное = увеличение, отрицательное = уменьшение. Напр.: 500 = рост на 500 в год",
      // eslint-disable-next-line no-template-curly-in-string
      escalationPreview: "В году {year}: {amount}",
      customYield: "Пользовательская доходность покупки",
      customYieldHelp:
        "Задайте пользовательскую доходность и профиль риска для приобретаемого актива",
      useCustomYield: "Использовать пользовательскую доходность",
      useCategoryDefault: "Использовать значение категории по умолчанию",
      expectedReturn: "Ожидаемая доходность (%)",
      standardDeviation: "Стандартное отклонение (%)",
      riskProfile: "Профиль риска",
      customProfileHint:
        "Для создания пользовательского профиля — перейдите на вкладку «Предположения о доходности»",
      loanAmount: "Сумма кредита",
      loanInterestRate: "Средняя годовая ставка (%)",
      loanPeriodMonths: "Срок (месяцы)",
      loanStartYear: "Год начала",
      loanEndYear: "Год окончания",
      loanTotalRepayment: "Общая сумма возврата",
      loanMonthlyPayment: "Ежемесячный платёж",
      loanPeriodHelp:
        "Вы можете изменить количество месяцев — год окончания обновится автоматически",
      pensionTaxWarningTitle: "Досрочное снятие пенсии — налог 35%",
      pensionTaxWarningBody:
        "Досрочное снятие из пенсионных фондов (до возраста права на пенсию) облагается налогом 35% от снимаемой суммы. Чистая сумма (после налога) будет добавлена как ликвидные средства в ваш портфель.",
      pensionGrossAmount: "Сумма брутто",
      pensionTax35: "Налог на досрочное снятие (35%)",
      pensionNetProceeds: "Нетто после налога",
    },
    assumptions: {
      title: "Предположения о доходности и риске",
      subtitle:
        "Настройте предположения о доходности для каждой категории активов",
      category: "Категория",
      return: "Ожидаемая доходность (%)",
      stddev: "Стандартное отклонение (%)",
      riskProfile: "Профиль риска",
      manageProfiles: "Управление профилями риска",
      cash: "Наличные",
      deposit: "Депозиты и сбережения",
      stocks: "Акции",
      crypto: "Крипто",
      rsu: "RSU / Опционы",
      pension: "Пенсия",
      realestate: "Недвижимость",
      other: "Другое",
      debt: "Кредиты",
    },
    riskProfiles: {
      title: "Управление профилями риска",
      subtitle:
        "Профили риска определяют диапазон волатильности доходности в симуляции",
      create: "Создать новый профиль",
      edit: "Редактировать",
      duplicate: "Дублировать",
      delete: "Удалить",
      save: "Сохранить",
      cancel: "Отмена",
      name: "Название профиля",
      downsideDelta: "Макс. снижение от среднего (%)",
      upsideDelta: "Макс. рост от среднего (%)",
      builtIn: "Встроенный",
      custom: "Пользовательский",
      readOnly: "Встроенный профиль (только чтение)",
      inUse: "Используется",
      cannotDelete: "Нельзя удалить профиль, который используется",
      confirmDelete: "Удалить этот профиль?",
      nameRequired: "Название профиля обязательно",
      deltaMustBePositive: "Значение должно быть положительным",
      tooltipBadYear: "Типичный плохой год (p5)",
      tooltipGoodYear: "Типичный хороший год (p95)",
      tooltipTruncated:
        "Симуляция использует усечённое нормальное распределение в этих границах",
      migrationBanner:
        "Модель риска обновлена до профилей — проверьте ваши предположения.",
      migrationDismiss: "Понятно",
    },
    breakdown: {
      title: "Состав активов",
      subtitle: "Как рассчитывается ваш портфель",
      product: "Продукт",
      category: "Категория",
      value: "Стоимость",
      ownership: "Владение",
      liquid: "Ликвидность",
      included: "Включён",
      totalAssets: "Итого активы",
      totalDebts: "Итого долги",
      netWorth: "Чистая стоимость",
      liquidAssets: "Ликвидные активы",
      nonLiquidAssets: "Неликвидные активы",
      spendableBeforeRetirement: "Доступно до пенсии",
      pensionLockedTitle: "Пенсия заблокирована до пенсионного возраста",
      pensionLockedSubtitle: "Будет добавлена к портфелю в возрасте {age}",
      currentPension: "Текущая стоимость",
      expectedPension: "Ожидается на пенсии",
      monthlyContribution: "Ежемесячный взнос",
      customYield: "Пользовательская доходность",
      customYieldHelp:
        "Задайте пользовательскую доходность и риск для этого продукта",
      useCustomYield: "Использовать пользовательскую доходность",
      useCategoryDefault: "Использовать значение категории по умолчанию",
      expectedReturn: "Ожидаемая доходность",
      standardDeviation: "Стандартное отклонение",
      riskProfile: "Профиль риска",
      hasCustomYield: "Пользовательская доходность",
      editCustomYield: "Редактировать доходность",
      clearCustomYield: "Очистить пользовательскую доходность",
    },
    pensionTab: {
      title: "Детализация пенсионных продуктов",
      subtitle: "Управление пенсионными продуктами и налоговыми последствиями",
      totalMonthlyPension: "Ожидаемая ежемесячная пенсия",
      totalLumpSum: "Единовременная выплата",
      totalCurrentValue: "Общая текущая стоимость",
      totalProjected: "Итого прогноз на пенсии",
      atRetirement: "На пенсии",
      perMonth: "/месяц",
      productClassLabel: "Тип продукта",
      withdrawalTypeLabel: "Тип снятия",
      mekademLabel: "Мекадем",
      eligibilityAgeLabel: "Возраст права",
      currentValueLabel: "Текущая стоимость",
      projectedValueLabel: "Прогноз на пенсии",
      monthlyPensionLabel: "Ежемесячная пенсия",
      lumpSumLabel: "Единовременная выплата",
      lumpSumTaxLabel: "Налог на единовременную выплату",
      monthlyContributionLabel: "Ежемесячный взнос",
      maslekaProjectionLabel: "Прогноз Маслека",
      earlyWithdrawal: "Досрочное снятие",
      earlyWithdrawalToggle: "Снять этот продукт (в выбранном возрасте)",
      withdrawAtAgeLabel: "Снять в возрасте (от текущего до пенсионного)",
      accumulatedAtAgeLabel: "Накопленная стоимость в возрасте {age}",
      earlyWithdrawalWarning:
        "Досрочное снятие облагается налогом 35% от полной суммы",
      earlyWithdrawalTax: "Налог на досрочное снятие (35%)",
      earlyWithdrawalNet: "Нетто после налога",
      earlyWithdrawalImpact:
        "Сумма будет добавлена как ликвидные активы и удалена из пенсионного прогноза",
      earlyKitzbaToggle: "Начать досрочный аннуитет (в выбранном возрасте)",
      startKitzbaAtAgeLabel:
        "Возраст начала аннуитета (с 60 до пенсионного)",
      earlyKitzbaExplanation:
        "Досрочное снятие в виде аннуитета: каждый год до официального пенсионного возраста повышает коэффициент на 12, поэтому ежемесячный аннуитет меньше — но начинается раньше и без налога 35%. Раньше на {years} лет.",
      earlyKitzbaMekademLabel: "Скорректированный коэффициент",
      earlyKitzbaMonthlyGrossLabel: "Ежемесячный аннуитет (брутто)",
      earlyKitzbaMonthlyNetLabel: "Ежемесячный аннуитет (нетто)",
      kitzba: "Аннуитет",
      hon: "Единовременная выплата",
      mixed: "Смешанный",
      noProducts: "Пенсионные продукты не найдены",
      ownerLabel: "Владелец",
      filterByOwner: "Фильтр по владельцу",
      filterAll: "Все",
      taxImplications: "Налоговые последствия",
      kitzbaTaxExemption: "Освобождение квалифицированной пенсии",
      kitzbaTaxNote:
        "До {amount} ₪/месяц освобождены от налога ({percent}% освобождение)",
      lumpSumTaxNote:
        "15% налог на прирост капитала на долю прибыли единовременной выплаты",
      earlyTaxNote: "35% налог на полную сумму при снятии до возраста права",
      summaryTitle: "Сводка пенсии на пенсии",
      netMonthlyAfterTax: "Чистая ежемесячная пенсия (после налога)",
      excludedProducts: "Ликвидные продукты (не включены в пенсию)",
      simulatorTitle: "Пенсионный симулятор",
      simulatorSubtitle:
        "Исследуйте различные пенсионные сценарии — возраст выхода, ежемесячная пенсия и досрочное снятие",
      pensionStartAge: "Возраст начала пенсии",
      pensionValueOverTime: "Стоимость пенсии во времени",
      monthlyPensionByAge: "Ежемесячная пенсия по возрасту начала",
      scenarioComparison: "Сравнение сценариев",
      scenarioAge: "Возраст",
      scenarioMonthly: "Ежемесячная пенсия",
      scenarioMonthlyNet: "Ежемесячная нетто",
      scenarioTotalValue: "Прогнозная стоимость",
      scenarioCumulativeIncome: "Совокупный доход к возрасту {life}",
      chartPensionValue: "Стоимость пенсии",
      chartMonthlyPension: "Ежемесячная пенсия (брутто)",
      chartMonthlyPensionNet: "Ежемесячная пенсия (нетто)",
      chartEarlyWithdrawal: "Досрочное снятие (нетто после 35% налога)",
      earlyPensionNote:
        "По израильскому законодательству некоторые продукты (накопительные фонды, инвестиционные фонды) позволяют получать пенсию с 60 лет.",
      selectedAge: "Выбранный возраст: {age}",
      atAge: "В возрасте {age}",
      tabValueOverTime: "Стоимость во времени",
      tabMonthlyByAge: "Пенсия по возрасту",
      tabDeposits: "Взносы",
      tabContributionTable: "Взносы и рост по годам",
      tableYear: "Год",
      tableAge: "Возраст",
      tableContributionYear: "Взнос (год)",
      tableGrowth: "Рост",
      tableValueEndOfYear: "Стоимость (конец года)",
      apply: "Применить",
    },
    warnings: {
      title: "Предупреждения",
    },
    buttons: {
      recalculate: "Пересчитать",
      resetDefaults: "Сбросить к предположениям по умолчанию",
      resetAllSettings: "Сбросить всё",
      resetAllSettingsConfirm: "Сбросить все настройки?",
      reloadFromData: "Перезагрузить из данных",
      moreActions: "Дополнительные действия",
      actions: "Действия",
      lastSaved: "Последнее сохранение",
      newDataAvailable: "Доступны новые данные",
      exportExcel: "Экспорт в Excel",
      exportExcelTooltip: "Скачать финансовый прогноз в виде файла Excel",
      exporting: "Экспорт...",
      exportError: "Ошибка экспорта",
      retirementGraphGuide: "Руководство по графику пенсии",
    },
    excel: {
      title: "Финансовый прогноз",
      subtitle: "Financial Projection",
      sheetName: "Пенсионный прогноз",
      userInfo: "Данные пользователя",
      currentAge: "Текущий возраст",
      retirementAge: "Пенсионный возраст",
      lifeExpectancy: "Ожидаемая продолжительность жизни",
      withdrawalRate: "Норма снятия",
      monthlySpend: "Ежемесячные расходы",
      monthlyIncome: "Ежемесячный доход",
      monthlySavings: "Ежемесячные сбережения",
      ageRow: "Возраст",
      yearRow: "Год",
      incomeSection: "Доходы",
      incomeImplied: "Ежемесячный доход (зарплата)",
      totalIncome: "Итого доходы",
      expenseSection: "Расходы",
      monthlyExpenses: "Ежемесячные расходы",
      totalExpenses: "Итого расходы",
      incomeMinusExpenses: "Доходы минус расходы",
      fireNumber: "Число FIRE",
      fireNumberBy4: "При 4%",
      fireNumberBy3: "При 3,3%",
      surplusDeficit: "Совокупный профицит / дефицит",
      assetsSection: "Активы",
      assetCurrentValue: "Текущая стоимость",
      assetReturn: "Доходность",
      totalAssets: "Итого активы",
      liquidAssets: "Из них ликвидные",
      lockedPension: "Заблокированная пенсия",
      liabilitiesSection: "Обязательства и разовые расходы",
      totalLiabilities: "Итого обязательства",
      netAssets: "Итого активы минус обязательства",
      poweredBy: "Powered by [REDACTED]",
      generatedAt: "Создано ",
    },
    monteCarloSettings: {
      simulations: "Количество симуляций",
      simulationsHelp: "Больше симуляций = точнее результаты (но медленнее)",
    },
    goals: {
      tabTitle: "Цели",
      title: "Пенсионные цели",
      subtitle:
        "Определите финансовые цели и проверьте вероятность их достижения",
      add: "Добавить цель",
      edit: "Редактировать",
      save: "Сохранить",
      cancel: "Отмена",
      delete: "Удалить",
      enabled: "Включена",
      disabled: "Отключена",
      goalName: "Название цели",
      targetAmount: "Целевая сумма",
      targetAmountHelp: "Сумма, которую вы хотите достичь",
      targetAge: "Целевой возраст",
      targetAgeHelp: "Возраст, к которому вы хотите достичь эту цель",
      kindPortfolioTarget: "Цель портфеля",
      kindPortfolioTargetDesc:
        "Накопить определённую сумму к определённому возрасту",
      kindPortfolioSurvives: "Выживание портфеля",
      kindPortfolioSurvivesDesc:
        "Деньги не закончатся до конца ожидаемой продолжительности жизни",
      kindFireByAge: "FIRE к возрасту",
      kindFireByAgeDesc:
        "Достичь финансовой независимости к определённому возрасту",
      kindMinimumFloor: "Минимальный порог",
      kindMinimumFloorDesc:
        "Портфель никогда не опускается ниже определённой суммы",
      kindPurchaseGoal: "Будущая покупка",
      kindPurchaseGoalDesc:
        "Купить актив в определённом возрасте — сумма снимается и проверяется выживание после",
      defaultSurvive: "Выживание до конца жизни",
      defaultBuyHome: "Покупка жилья",
      defaultFireByAge: "Финансовая независимость",
      defaultMinFloor: "Минимальный порог",
      defaultPurchase: "Покупка жилья",
      overallSuccess: "Шанс достижения всех целей",
      goalSuccess: "Вероятность успеха",
      deterministicMet: "Достигнута в прогнозе",
      deterministicNotMet: "Не достигнута в прогнозе",
      metAtAge: "Достигнута в возрасте",
      noGoals: "Цели не определены",
      noGoalsSubtitle: "Добавьте цель, чтобы увидеть вероятность её достижения",
      presets: "Шаблоны целей",
      addFromPreset: "Добавить из шаблона",
    },
    aiChat: {
      title: "Планирование с ИИ",
      subtitle: "Опишите ваши планы и ИИ создаст персонализированный сценарий",
      placeholder:
        "Расскажите о ваших планах... например: Я хочу купить квартиру через 5 лет, отправить детей на учёбу...",
      send: "Отправить",
      apply: "Применить сценарий",
      applyAndClose: "Применить и закрыть",
      preview: "Предпросмотр",
      generating: "Генерация сценария...",
      error: "Ошибка генерации сценария",
      errorRetry: "Попробовать снова",
      close: "Закрыть",
      eventsPreview: "Жизненные события",
      goalsPreview: "Цели",
      scenarioName: "Название сценария",
      noEventsGenerated: "События не сгенерированы",
      noGoalsGenerated: "Цели не сгенерированы",
      appliedSuccess: "Сценарий успешно применён!",
      suggestedRetirementAge: "Рекомендуемый пенсионный возраст",
      acceptSuggestion: "Принять",
      openButton: "Планирование с ИИ",
      openButtonTooltip:
        "Опишите ваши планы и ИИ создаст персонализированный сценарий",
      newChat: "Новый чат",
      eventCount: "событий",
      goalCount: "целей",
      voiceListening: "Слушаю...",
      voiceTapToSpeak: "Нажмите для записи",
      voiceTapToStop: "Нажмите для остановки и отправки",
      voiceNotSupported: "Голосовой ввод не поддерживается в этом браузере",
      direction: {
        inflow: "Доход",
        outflow: "Расход",
      },
      frequency: {
        oneTime: "Разовый",
        monthly: "Ежемесячно",
        yearly: "Ежегодно",
      },
    },
    ui: {
      eventTypes: {
        buy: "Покупка",
        sell: "Продажа",
        loan: "Кредит",
      },
      lifeEventIcons: {
        home: "Дом",
        car: "Автомобиль",
        school: "Образование",
        baby: "Ребёнок",
        family: "Семья",
        flight: "Перелёт / Отпуск",
        work: "Работа",
        medical: "Медицина",
        celebration: "Праздник / Свадьба",
        gift: "Подарок",
        restaurant: "Рестораны / Еда",
        fitness: "Спорт / Здоровье",
        pets: "Домашние животные",
        renovation: "Ремонт",
        laptop: "Технологии",
        trendingUp: "Рост / Увеличение",
        trendingDown: "Снижение / Падение",
        savings: "Сбережения",
        beach: "Пенсия / Отдых",
        donate: "Пожертвование",
        bank: "Банк / Кредит",
        shopping: "Покупки",
      },
    },
    help: {
      fire: {
        title: "🔥 Что такое FIRE?",
        p1Text:
          "(Financial Independence, Retire Early) — это финансовое движение, направленное на достижение финансовой независимости — состояния, при котором у вас достаточно активов для покрытия расходов на жизнь, не работая. Это не обязательно означает увольнение — работа становится",
        p1Choice: "выбором",
        p1Separator: ", а не ",
        p1Necessity: "необходимостью",
        p2Text:
          "Идея проста: накопите достаточно средств, чтобы их годовая доходность покрывала ваши расходы. Эта сумма называется",
        p2FireNumber: "числом FIRE",
      },
      goals: {
        title: "🎯 Пенсионные цели",
        introTitle: "Что такое пенсионные цели?",
        introDesc:
          "Вместо единственного числа FIRE, калькулятор позволяет определить личные цели, отражающие ваши финансовые задачи. Каждая цель получает собственную вероятность успеха.",
        typesTitle: "Типы целей",
        typePortfolioSurvivesTitle: "🏖️ Выживание портфеля",
        typePortfolioSurvivesDesc:
          "Самая основная цель — деньги не закончатся до ожидаемой продолжительности жизни. Калькулятор проверяет, сколько сценариев симуляции заканчиваются с положительным портфелем.",
        typePortfolioTargetTitle: "🏠 Цель портфеля к возрасту",
        typePortfolioTargetDesc:
          "Хотите достичь ₪X к возрасту Y? Например: ₪2 000 000 к 55 годам для покупки жилья. Калькулятор проверяет, в каком проценте сценариев портфель достиг этой суммы.",
        typePurchaseTitle: "🛒 Будущая покупка",
        typePurchaseDesc:
          "Запланируйте крупный расход в определённом возрасте (жильё, авто, свадьба). Эта цель проверяет, может ли портфель покрыть покупку, и автоматически создаёт жизненное событие расхода, вычитающее сумму из портфеля.",
        typeFireByAgeTitle: "📈 FIRE к возрасту",
        typeFireByAgeDesc:
          "Достичь финансовой независимости (числа FIRE) к определённому возрасту. Калькулятор проверяет, в каком проценте сценариев вы достигли цели.",
        typeMinFloorTitle: "💰 Минимальный порог",
        typeMinFloorDesc:
          "Поддержание минимального баланса портфеля на протяжении всей пенсии, например ₪500 000 как страховочная сетка. Калькулятор проверяет, что портфель не опускается ниже этой суммы.",
        howItWorksTitle: "Как это работает?",
        howItWorksDesc:
          "Каждая цель получает отдельную вероятность успеха — шанс её достижения во всех симуляциях Monte Carlo. Также показана общая вероятность успеха — шанс достижения всех целей одновременно.",
        tipsTitle: "Советы",
        tip1: "Начните с базовой цели выживания портфеля — это самая важная цель",
        tip2: "Добавьте цели покупки для планирования крупных расходов (они автоматически создают жизненные события)",
        tip3: "Включайте/выключайте цели, чтобы увидеть, как они влияют на общую вероятность",
        tip4: "Стремитесь к вероятности успеха выше 80% для каждой цели",
      },
      keyNumbers: {
        title: "📊 Числа над графиком",
        fireNumberTitle: "Число FIRE — сколько нужно?",
        fireNumberDesc:
          "Общая сумма, которую нужно накопить для выхода на пенсию. Рассчитывается как: годовые расходы ÷ норма снятия.",
        fireNumberExample:
          "Например: если ежемесячные расходы ₪15 000 (₪180 000/год) и норма снятия 4%, число FIRE равно",
        fireNumberExampleValue: "₪4 500 000",
        yearsTitle: "Лет до FIRE — когда можно на пенсию?",
        yearsDesc:
          "Количество лет для достижения числа FIRE на основе текущего портфеля, ежемесячных сбережений и ожидаемой доходности. Если число слишком велико — попробуйте увеличить сбережения, сократить расходы или рассмотреть более высокую норму снятия.",
        successTitle: "Вероятность успеха — насколько это надёжно?",
        successDesc:
          "Появляется при включённой симуляции Monte Carlo. Показывает процент сценариев, в которых деньги не заканчиваются до конца ожидаемой продолжительности жизни.",
        successThresholds: "Выше 80% считается хорошо, выше 90% — отлично.",
      },
      withdrawalRate: {
        title: "💰 Норма снятия — важнейшая концепция FIRE",
        p1Label: "Норма снятия",
        p1Text:
          "— это процент, который вы снимаете из портфеля каждый год для покрытия расходов. Она определяет, сколько денег нужно накопить (число FIRE = годовые расходы ÷ норма снятия).",
        p2Label: "Правило 4%:",
        p2Text:
          "Известное исследование Trinity Study показало, что снятие 4% в год из портфеля акций и облигаций пережило почти все исторические периоды (30+ лет) на американском рынке.",
        examplesTitle: "Примеры — ежемесячные расходы ₪15 000 (₪180 000/год):",
        colWithdrawalRate: "Норма снятия",
        colFireNumber: "Число FIRE",
        colConfidence: "Уровень уверенности",
        colSuitableFor: "Подходит для...",
        row3Confidence: "Очень высокий",
        row3Suitable: "Досрочная пенсия (30+ лет), консервативные инвесторы",
        row4Confidence: "Высокий",
        row4Suitable: "Рекомендуемое значение по умолчанию, стандартная пенсия",
        row5Confidence: "Средний",
        row5Suitable: "Поздняя пенсия, дополнительный доход (пенсия, аренда)",
        row6Confidence: "Ниже среднего",
        row6Suitable: "Имеется значительный дополнительный постоянный доход",
        footerText:
          "Чем ниже норма снятия, тем больше нужно накопить — но шанс, что деньги продержатся, значительно возрастает.",
      },
      calculator: {
        title: "🧮 Что делает этот калькулятор?",
        autoCalcLabel: "Автоматический расчёт",
        autoCalcDesc:
          "Загружает все ваши активы, расходы и доходы напрямую из ваших данных в системе",
        visualLabel: "Визуальный прогноз",
        visualDesc:
          "График, показывающий рост вашего портфеля на протяжении лет, до и после выхода на пенсию",
        monteCarloLabel: "Симуляция Monte Carlo",
        monteCarloDesc:
          "Сотни случайных сценариев, показывающих диапазон возможных результатов и вероятность успеха",
        lifeEventsLabel: "Жизненные события",
        lifeEventsDesc:
          "Планируйте будущие события (покупка жилья, наследство, образование детей) и смотрите, как они влияют на прогноз",
        scenariosLabel: "Сценарии",
        scenariosDesc:
          "Сравнивайте различные сценарии (оптимистичный, пессимистичный) для принятия обоснованных решений",
        goalsLabel: "Личные цели",
        goalsDesc:
          "Определите пенсионные цели (выживание портфеля, будущие покупки, FIRE) и смотрите вероятность достижения каждой",
        customLabel: "Полная настройка",
        customDesc:
          "Настраивайте предположения о доходности, профили риска, включайте/исключайте активы по необходимости",
      },
      graphElements: {
        title: "📊 Что показано на графике",
        projectionTitle: "Линия прогноза (синяя)",
        projectionDesc:
          "Детерминистический прогноз стоимости вашего портфеля на протяжении лет. Основан на предположениях о доходности, заданных для каждой категории активов.",
        monteCarloBandsTitle: "Полосы Monte Carlo",
        p90Label: "P90 (зелёная)",
        p90Desc:
          "Оптимистичный сценарий (только 10% симуляций дали лучший результат)",
        p50Label: "P50 (оранжевая)",
        p50Desc: "Медиана (50% симуляций были выше/ниже этой линии)",
        p10Label: "P10 (красная)",
        p10Desc:
          "Пессимистичный сценарий (90% симуляций дали лучший результат)",
        fireLineTitle: "Линия FIRE (зелёная пунктирная)",
        fireLineDesc:
          "Сумма, необходимая для выхода на пенсию. Рассчитывается как: годовые расходы ÷ безопасная норма снятия.",
        fireLineExample:
          "Например: если ежемесячные расходы ₪20 000 и норма снятия 4%, число FIRE равно ₪6 000 000.",
        retirementLineTitle: "Линия пенсии (синяя пунктирная)",
        retirementLineDesc:
          "Возраст, в котором вы планируете прекратить работу. С этого момента, вместо добавления сбережений, вы начинаете снимать из портфеля.",
      },
      calculation: {
        title: "🧮 Как рассчитывается прогноз",
        accumulationTitle: "Фаза накопления (до пенсии)",
        accumulationItem1:
          "Ежемесячные сбережения накапливаются как «кредит на покупку» (не инвестируются автоматически)",
        accumulationItem2:
          "Существующие активы растут по доходности, заданной для каждой категории",
        accumulationItem3:
          "Жизненные события (покупки, продажи, доходы) влияют на портфель",
        withdrawalTitle: "Фаза снятия (после пенсии)",
        withdrawalItem1:
          "Каждый год снимаются ежемесячные расходы × 12, скорректированные на инфляцию",
        withdrawalItem2Label: "Важно:",
        withdrawalItem2Text:
          "Снятия основаны на фактических расходах, а не на норме снятия",
        withdrawalItem3: "Активы продолжают расти за вычетом снятий",
        inflationTitle: "Поправка на инфляцию",
        inflationDesc:
          "Все суммы (расходы, снятия) корректируются на заданную инфляцию. Если расходы сегодня ₪15 000 и инфляция 2%, через 10 лет они составят ₪18 285.",
      },
      pension: {
        title: "🏦 Пенсия",
        whenTitle: "Когда начинается пенсия?",
        whenDesc: "Пенсия заблокирована до законного возраста права:",
        whenForMales: "для мужчин,",
        whenForFemales: "для женщин",
        whenEarlyRetirement:
          "Даже при досрочном выходе на пенсию, пенсия будет добавлена только в возрасте права.",
        includedTitle: "Что включено в расчёт пенсии?",
        includedItem1: "Текущая стоимость пенсионных фондов",
        includedItem2:
          "Будущие взносы (работник + работодатель) до возраста права",
        includedItem3: "Ожидаемая доходность (~4,3% в год)",
        includedItem4:
          "Комиссии за управление (от взносов и накопленного баланса)",
        excludedLabel: "Не включено:",
        excludedText:
          "Образовательные фонды (Керен Иштальмут) — ликвидны до пенсионного возраста",
        graphTitle: "На графике",
        graphDesc:
          "В возрасте права на пенсию аннуитетные продукты начинают обеспечивать стабильный ежемесячный доход, уменьшающий снятия из портфеля. Единовременные продукты добавляются к портфелю разовой суммой.",
      },
      pensionLaw: {
        title: "📋 Израильское пенсионное законодательство",
        productTypesTitle: "Типы пенсионных продуктов",
        productTypesDesc:
          "Каждый пенсионный продукт ведёт себя по-разному при выходе на пенсию:",
        kerenPensiaTitle: "Керен Пенсия (аннуитетный пенсионный фонд)",
        kerenPensiaDesc:
          "Самый распространённый продукт. Накопления конвертируются в ежемесячный аннуитет при выходе на пенсию с помощью коэффициента конверсии (мекадем). Включает страхование инвалидности и иждивенцев.",
        bituachMenahalimTitle: "Битуах Менахалим (страхование менеджеров)",
        bituachMenahalimDesc:
          "Полис страхования жизни с компонентом сбережений. Может быть погашен как аннуитет, единовременная выплата или их комбинация. Включает страхование инвалидности и иждивенцев.",
        kupatGemelKitzbatitTitle: "Купат Гемель (аннуитетная, после 2008)",
        kupatGemelKitzbatitDesc:
          "Взносы с 2008 года предназначены только для аннуитета и не могут быть погашены единовременно.",
        kupatGemelHonitTitle: "Купат Гемель (единовременная, до 2008)",
        kupatGemelHonitDesc:
          "Взносы, сделанные до 2008 года, могут быть погашены как единовременная выплата без налогов с 60 лет.",
        kupatGemelLehashkaaTitle:
          "Купат Гемель ЛеХашкаа (инвестиционный накопительный фонд)",
        kupatGemelLehashkaaDesc:
          "Погашается с 60 лет как единовременная выплата (15% налог на прирост капитала) или как аннуитет без налогов. Годовой лимит взносов ~82 000 ILS.",
        kerenHishtalmutTitle: "Керен Иштальмут (образовательный фонд)",
        kerenHishtalmutDesc:
          "Ликвиден после 6 лет стажа, полностью освобождён от налогов. Не является пенсионным продуктом — отображается в категории «Другое» и не заблокирован до пенсии.",

        mekademTitle: "Коэффициент аннуитета (Мекадем)",
        mekademDesc:
          "Мекадем определяет размер ежемесячной пенсии из ваших накоплений:",
        mekademFormula: "Ежемесячная пенсия = Общие накопления ÷ Мекадем",
        mekademExample: "Пример: 1 000 000 ILS ÷ мекадем 220 = 4 545 ILS/месяц",
        mekademFactorsTitle: "Что влияет на Мекадем?",
        mekademFactor1:
          "Возраст выхода на пенсию — ниже мекадем (выше пенсия) при более позднем выходе",
        mekademFactor2:
          "Пол — выше мекадем (ниже пенсия) для женщин из-за большей ожидаемой продолжительности жизни",
        mekademFactor3:
          "Семейное положение — выше мекадем для женатых из-за пенсии иждивенцев",
        mekademSourceTitle: "Источник Мекадем",
        mekademSourceDesc:
          "Если в данных Маслека есть гарантированный мекадем, калькулятор использует его. Иначе используется актуарная таблица по умолчанию.",

        taxTitle: "Налогообложение пенсии",
        taxKitzbaTitle: "Ежемесячный аннуитет на пенсии",
        taxKitzbaDesc:
          "Квалифицированная пенсия (до 9 430 ILS/месяц) освобождена от налога с возрастающей ставкой: 57% в 2025, 60% в 2026, до 67% в 2028. Сумма сверх освобождения облагается предельной ставкой.",
        taxLumpSumTitle: "Единовременное снятие",
        taxLumpSumDesc:
          "Поправка 190: 15% реальный налог на прирост капитала только на долю прибыли (по сравнению с 25% на рынке капитала).",
        taxEarlyTitle: "Досрочное снятие (до пенсионного возраста)",
        taxEarlyDesc:
          "Фиксированный налог 35% на всю сумму снятия. Невозвратный (за исключением инвалидности или тяжёлой болезни).",

        contributionsTitle: "Влияние дохода на взносы",
        contributionsDesc:
          "Пенсионные взносы рассчитываются от зарплаты (6% работник + 6,5% работодатель + 6-8,33% выходное пособие). При снижении дохода (переход на частичную занятость, досрочная пенсия) взносы уменьшаются пропорционально, снижая ожидаемые накопления к пенсии.",
        contributionsRetirement:
          "При выходе на пенсию взносы прекращаются полностью.",

        pitzuimTitle: "Выходное пособие (Пицуим)",
        pitzuimDesc:
          "Около 40% пенсионных накоплений приходится на взносы работодателя в счёт выходного пособия. Досрочное снятие пособия значительно снижает будущий пенсионный аннуитет.",

        retirementAgeTitle: "Пенсионный возраст",
        retirementAgeDesc:
          "Право на пенсию: 67 для мужчин, 65 для женщин. Досрочный выход возможен, но без пенсионного дохода до возраста права — период разрыва нужно финансировать из ликвидного портфеля.",
      },
      monteCarlo: {
        title: "🎲 Симуляция Monte Carlo",
        whatTitle: "Что это?",
        whatDesc:
          "Вместо фиксированной доходности симуляция запускает сотни случайных сценариев. Для каждой категории активов задан профиль риска, определяющий диапазон колебаний — симуляция случайным образом генерирует годовую доходность в этом диапазоне каждый год.",
        successTitle: "Вероятность успеха",
        successDesc:
          "Процент симуляций, в которых портфель не заканчивается до конца ожидаемой продолжительности жизни.",
        successAbove90: "Выше 90% — отлично",
        success75to90: "75–90% — хорошо",
        successBelow75:
          "Ниже 75% — стоит увеличить сбережения или сократить расходы",
        whyTitle: "Почему это важно?",
        whyDesc:
          "Рынки не растут с постоянной скоростью. Бывают отличные годы (+20%) и ужасные годы (−30%). Monte Carlo помогает понять диапазон возможных результатов.",
      },
      riskProfilesHelp: {
        title: "🎯 Профили риска",
        whatTitle: "Что такое профиль риска?",
        whatDesc:
          "Профиль риска определяет диапазон волатильности доходности в симуляции. Вместо ручного ввода стандартного отклонения вы выбираете профиль, описывающий интенсивность колебаний — как сильно актив может упасть в плохой год и как сильно вырасти в хороший.",
        howTitle: "Как это работает?",
        howDesc: "Каждый профиль определяется двумя числами:",
        howP5Label: "Типичное максимальное падение (p5)",
        howP5Desc:
          "В плохой год (1 из 20) доходность падает примерно на эту величину ниже среднего",
        howP95Label: "Типичный максимальный рост (p95)",
        howP95Desc:
          "В хороший год (1 из 20) доходность растёт примерно на эту величину выше среднего",
        howDistribution:
          "Симуляция использует усечённое нормальное распределение в этих границах для генерации реалистичных случайных доходностей.",
        examplesTitle: "Практические примеры",
        exBankTitle:
          "🏦 Банковский депозит — профиль «Консервативный» (↓3% / ↑5%)",
        exBankStats:
          "Ожидаемая доходность: 3% | Плохой год: 0% | Хороший год: 8%",
        exBankDesc:
          "Портфель ₪500 000 — в большинстве лет вы заработаете ₪10 000–₪40 000. Почти нет риска потерь.",
        exStocksTitle: "📈 Индекс S&P 500 — профиль «Рост» (↓20% / ↑30%)",
        exStocksStats:
          "Ожидаемая доходность: 7% | Плохой год: −13% | Хороший год: 37%",
        exStocksDesc:
          "Портфель ₪500 000 — в хороший год можно заработать ₪185 000, но в плохой — потерять ₪65 000.",
        exCryptoTitle: "₿ Крипто — профиль «Спекулятивный» (↓40% / ↑75%)",
        exCryptoStats:
          "Ожидаемая доходность: 10% | Плохой год: −30% | Хороший год: 85%",
        exCryptoDesc:
          "Портфель ₪500 000 — может упасть до ₪350 000 в плохой год, но также вырасти до ₪925 000 в хороший.",
        defaultsTitle: "Профили по умолчанию по категориям",
        defaultsDesc:
          "Каждой категории активов автоматически назначается подходящий профиль риска:",
        defaultCash: "Наличные",
        defaultCashProfile: "Сохранение капитала (минимальная волатильность)",
        defaultDeposits: "Депозиты",
        defaultDepositsProfile: "Консервативный",
        defaultPension: "Пенсия",
        defaultPensionProfile: "Сбалансированный",
        defaultRealestate: "Недвижимость",
        defaultRealestateProfile: "Умеренный рост",
        defaultStocks: "Акции",
        defaultStocksProfile: "Рост",
        defaultRsu: "RSU / Опционы",
        defaultRsuProfile: "Агрессивный",
        defaultCrypto: "Крипто",
        defaultCryptoProfile: "Спекулятивный",
        customTitle: "Пользовательские профили",
        customDesc:
          "Вы можете создать пользовательские профили риска через кнопку «Управление профилями риска» на вкладке",
        customDescTab: "Предположения о доходности",
        customExample:
          "Например: если вы инвестируете в консервативный фонд акций, который ведёт себя иначе, чем S&P, вы можете создать профиль с ↓12% / ↑18%, лучше описывающий поведение фонда.",
      },
      lifeEvents: {
        title: "📅 Жизненные события",
        typesTitle: "Типы событий",
        typeIncomeExpenseLabel: "Доход/Расход",
        typeIncomeExpenseDesc:
          "Деньги, поступающие или уходящие (наследство, свадьба, образование)",
        typeBuyLabel: "Покупка актива",
        typeBuyDesc: "Инвестиция в определённую категорию",
        typeSellLabel: "Продажа актива",
        typeSellDesc: "Ликвидация активов (переводится в кредит на покупку)",
        creditTitle: "Кредит на покупку",
        creditDesc:
          "Деньги, которые накопились и ждут инвестирования. Состоят из:",
        creditItem1: "Ежемесячные сбережения, которые не были инвестированы",
        creditItem2: "Выручка от продажи активов",
        creditItem3: "Разовые доходы",
        creditNote: "Примечание:",
        creditNoteText:
          "Кредит на покупку не растёт (0% доходности) пока не будет использован для покупки актива.",
      },
      tips: {
        title: "💡 Советы",
        tip1: "Указывайте реалистичные ежемесячные расходы — это самый критичный параметр",
        tip2: "Добавьте ожидаемые жизненные события (образование детей, покупка жилья, наследство)",
        tip3: "Используйте Monte Carlo для просмотра диапазона возможных результатов",
        tip4: "Проверяйте вероятность успеха — стремитесь к значению выше 80%",
        tip5Warning:
          "Прогноз основан на предположениях — реальность может отличаться",
      },
    },
  },
};

export type TranslationKey = typeof translations.HEB;
// Legacy export for backward compatibility - prefer using translations[lang] directly
export const t = translations.HEB;
